/* eslint-disable prettier/prettier */
/* eslint-disable react/prop-types */

import TextField from "@mui/material/TextField";
import Alert from "@mui/material/Alert";
import Autocomplete from "@mui/material/Autocomplete";
import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { useState, state, useImperativeHandle, forwardRef, useEffect } from "react";
import toast from "react-hot-toast";
import moment from "moment";

import Button from "@mui/material/Button";

const EvaluacionAuditiva = forwardRef(
  ({ Back, Next, props, vista = "registrar", desactivar }, ref) => {
    const [IdiomaMadre, setIdiomaMadre] = useState(props?.idiomaMadre ? props.idiomaMadre : "");
    const [isvalid_IdiomaMadre, isvalid_setIdiomaMadre] = useState(false);

    const [IdiomaPadre, setIdiomaPadre] = useState(props?.idiomaPadre ? props.idiomaPadre : "");
    const [isvalid_IdiomaPadre, isvalid_setIdiomaPadre] = useState(false);

    const [IdiomaEnCasa, setIdiomaEnCasa] = useState(props?.idiomaEnCasa ? props.idiomaEnCasa : "");
    const [isvalid_IdiomaEnCasa, isvalid_setIdiomaEnCasa] = useState(false);

    const [EvaluadoAudiologia, setEvaluadoAudiologia] = useState(props?.evaluadoAudiologia ?? null);
    const [isvalid_EvaluadoAudiologia, isvalid_setEvaluadoAudiologia] = useState(false);

    const [AudiologoEvalua, setAudiologoEvalua] = useState(
      props?.audiologoEvalua ? props.audiologoEvalua : ""
    );
    const [isvalid_AudiologoEvalua, isvalid_setAudiologoEvalua] = useState(false);

    const [EvaluadoOtorrino, setEvaluadoOtorrino] = useState(props?.evaluadoOtorrino ?? null);
    const [isvalid_EvaluadoOtorrino, isvalid_setEvaluadoOtorrino] = useState(false);

    const [OtorrinoEvalua, setOtorrinoEvalua] = useState(
      props?.otorrinoEvalua ? props.otorrinoEvalua : ""
    );
    const [isvalid_OtorrinoEvalua, isvalid_setOtorrinoEvalua] = useState(false);

    const [EvaluadoTerapiaLenguaje, setEvaluadoTerapiaLenguaje] = useState(
      props?.evaluadoTerapiaLenguaje ?? null
    );
    const [isvalid_EvaluadoTerapiaLenguaje, isvalid_setEvaluadoTerapiaLenguaje] = useState(false);

    const [TerapeutaEvalua, setTerapeutaEvalua] = useState(
      props?.terapeutaEvalua ? props.terapeutaEvalua : ""
    );
    const [isvalid_TerapeutaEvalua, isvalid_setTerapeutaEvalua] = useState(false);

    const [FechaPerdidaAuditiva, setFechaPerdidaAuditiva] = useState("");

    useEffect(() => {
      const fecha = props?.fechaPerdidaAuditiva;

      const formatosValidos = [
        "YYYY-MM-DDTHH:mm:ss", // ISO con tiempo
        "YYYY-MM-DD", // ISO sin tiempo
        "DD/MM/YYYY", // común en español
        "YYYY/MM/DD", // común en bases de datos
        "DD-MM-YYYY", // con guiones
        "YYYY.MM.DD", // con puntos
      ];

      const fechaMoment = moment(fecha, formatosValidos, true); // true = validación estricta

      if (fechaMoment.isValid()) {
        const fechaFormateada = fechaMoment.format("DD/MM/YYYY");
        setFechaPerdidaAuditiva(fechaFormateada);
      } else {
        setFechaPerdidaAuditiva(props?.fechaPerdidaAuditiva || "");
      }
    }, [props?.fechaPerdidaAuditiva]);

    const [isvalid_FechaPerdidaAuditiva, isvalid_setFechaPerdidaAuditiva] = useState(false);

    const [TiempoInicioPerdidaAud, setTiempoInicioPerdidaAud] = useState(
      props?.tiempoInicioPerdidaAud ? props.tiempoInicioPerdidaAud : ""
    );
    const [isvalid_TiempoInicioPerdidaAud, isvalid_setTiempoInicioPerdidaAud] = useState(false);

    const [ProfQueDiagnostico, setProfQueDiagnostico] = useState(
      props?.profQueDiagnostico ? props.profQueDiagnostico : ""
    );
    const [isvalid_ProfQueDiagnostico, isvalid_setProfQueDiagnostico] = useState(false);

    const [CausaPerdidaAuditiva, setCausaPerdidaAuditiva] = useState(
      props?.causaPerdidaAuditiva ? props.causaPerdidaAuditiva : ""
    );
    const [isvalid_CausaPerdidaAuditiva, isvalid_setCausaPerdidaAuditiva] = useState(false);

    const [IdTipoPerdidaAuditiva, setIdTipoPerdidaAuditiva] = useState(
      props?.idTipoPerdidaAuditiva ?? null
    );
    const [isvalid_IdTipoPerdidaAuditiva, isvalid_setIdTipoPerdidaAuditiva] = useState(false);

    const [GradoHipoacusia, setGradoHipoacusia] = useState(
      props?.gradoHipoacusia ? props.gradoHipoacusia : ""
    );
    const [isvalid_GradoHipoacusia, isvalid_setGradoHipoacusia] = useState(false);

    const [TieneEstudiosAudicion, setTieneEstudiosAudicion] = useState(
      props?.tieneEstudiosAudicion ?? null
    );
    const [isvalid_TieneEstudiosAudicion, isvalid_setTieneEstudiosAudicion] = useState(false);

    const [EstudiosAudicion, setEstudiosAudicion] = useState(
      props?.estudiosAudicion ? props.estudiosAudicion : ""
    );
    const [isvalid_EstudiosAudicion, isvalid_setEstudiosAudicion] = useState(false);

    const [DiagnosticoAudicion, setDiagnosticoAudicion] = useState(
      props?.diagnosticoAudicion ? props.diagnosticoAudicion : ""
    );
    const [isvalid_DiagnosticoAudicion, isvalid_setDiagnosticoAudicion] = useState(false);

    const [UtilizaAuxAuditivos, setUtilizaAuxAuditivos] = useState(
      props?.utilizaAuxAuditivos ?? null
    );
    const [isvalid_UtilizaAuxAuditivos, isvalid_setUtilizaAuxAuditivos] = useState(false);

    const [MarcaAuxAuditivos, setMarcaAuxAuditivos] = useState(
      props?.marcaAuxAuditivos ? props.marcaAuxAuditivos : ""
    );
    const [isvalid_MarcaAuxAuditivos, isvalid_setMarcaAuxAuditivos] = useState(false);

    let fechaAdap = "";
    if (
      typeof props?.fechaAdaptacionAuxiliaresAud === "string" &&
      props?.fechaAdaptacionAuxiliaresAud.includes("T")
    ) {
      fechaAdap = moment(props.fechaAdaptacionAuxiliaresAud).format("YYYY-MM-DD");
    } else {
      fechaAdap = props?.fechaAdaptacionAuxiliaresAud ? props.fechaAdaptacionAuxiliaresAud : "";
    }
    const [FechaAdaptacionAuxAud, setFechaAdaptacionAuxAud] = useState(
      fechaAdap != "1900-01-01" ? fechaAdap : ""
    );
    const [isvalid_FechaAdaptacionAuxAud, isvalid_setFechaAdaptacionAuxAud] = useState(false);

    const [HaAjustadoAuxAuditivos, setHaAjustadoAuxAuditivos] = useState(
      props?.haAjustadoAuxAuditivos ?? null
    );
    const [isvalid_HaAjustadoAuxAuditivos, isvalid_setHaAjustadoAuxAuditivos] = useState(false);

    let fechaAjuste = "";
    if (
      typeof props?.fechaAjusteAuxAuditivos === "string" &&
      props?.fechaAjusteAuxAuditivos.includes("T")
    ) {
      fechaAjuste = moment(props.fechaAjusteAuxAuditivos).format("YYYY-MM-DD");
    } else {
      fechaAjuste = props?.fechaAjusteAuxAuditivos ? props.fechaAjusteAuxAuditivos : "";
    }
    const [FechaAjusteAuxAuditivos, setFechaAjusteAuxAuditivos] = useState(
      fechaAjuste != "1900-01-01" ? fechaAjuste : ""
    );
    const [isvalid_FechaAjusteAuxAuditivos, isvalid_setFechaAjusteAuxAuditivos] = useState(false);

    const [AudiologoAjuste, setAudiologoAjuste] = useState(
      props?.audiologoAjuste ? props.audiologoAjuste : ""
    );
    const [isvalid_AudiologoAjuste, isvalid_setAudiologoAjuste] = useState(false);

    const [HaRecibidoTerapiaAudVerbal, setHaRecibidoTerapiaAudVerbal] = useState(
      props?.haRecibidoTerapiaAudVerbal ?? null
    );
    const [isvalid_HaRecibidoTerapiaAudVerbal, isvalid_setHaRecibidoTerapiaAudVerbal] =
      useState(false);

    const [TerapiaAudVerbalQuien, setTerapiaAudVerbalQuien] = useState(
      props?.terapiaAudVerbalQuien ? props.terapiaAudVerbalQuien : ""
    );
    const [isvalid_TerapiaAudVerbalQuien, isvalid_setTerapiaAudVerbalQuien] = useState(false);

    const [ProgresosObtenidos, setProgresosObtenidos] = useState(
      props?.progresosObtenidos ? props.progresosObtenidos : ""
    );
    const [isvalid_ProgresosObtenidos, isvalid_setProgresosObtenidos] = useState(false);

    const [LenguajeActual, setLenguajeActual] = useState(
      props?.lenguajeActual ? props.lenguajeActual : ""
    );
    const [isvalid_LenguajeActual, isvalid_setLenguajeActual] = useState(false);

    const [EscuchaActualmente, setEscuchaActualmente] = useState(
      props?.escuchaActualmente ? props.escuchaActualmente : ""
    );
    const [isvalid_EscuchaActualmente, isvalid_setEscuchaActualmente] = useState(false);

    const [TieneEvaluacionVista, setTieneEvaluacionVista] = useState(
      props?.tieneEvaluacionVista ?? null
    );
    const [isvalid_TieneEvaluacionVista, isvalid_setTieneEvaluacionVista] = useState(false);

    const [TieneRetrasoDesarrollo, setTieneRetrasoDesarrollo] = useState(
      props?.tieneRetrasoDesarrollo ?? null
    );
    const [isvalid_TieneRetrasoDesarrollo, isvalid_setTieneRetrasoDesarrollo] = useState(false);

    const [CualRetraso, setCualRetraso] = useState(props?.cualRetraso ? props.cualRetraso : "");
    const [isvalid_CualRetraso, isvalid_setCualRetraso] = useState(false);

    const ValidaForm = () => {
      if (!IdiomaMadre) {
        toast.error("Idioma de la Madre: Campo obligatorio *");
        isvalid_setIdiomaMadre(true);
        return null;
      }

      if (!IdiomaPadre) {
        toast.error("Idioma del Padre: Campo obligatorio *");
        isvalid_setIdiomaPadre(true);
        return null;
      }

      if (!IdiomaEnCasa) {
        toast.error("Idioma en Casa: Campo obligatorio *");
        isvalid_setIdiomaEnCasa(true);
        return null;
      }

      if (EvaluadoAudiologia == null || EvaluadoAudiologia == undefined) {
        toast.error("¿Ha sido evaluado por un Audiologo?: Campo obligatorio *");
        isvalid_setEvaluadoAudiologia(true);
        return null;
      }

      if (!AudiologoEvalua && EvaluadoAudiologia == "1") {
        toast.error("Nombre Audiólogo: Campo obligatorio *");
        isvalid_setAudiologoEvalua(true);
        return null;
      }

      if (EvaluadoOtorrino == null || EvaluadoOtorrino == undefined) {
        toast.error("¿Ha sido evaluado por un Otorrino?: Campo obligatorio *");
        isvalid_setEvaluadoOtorrino(true);
        return null;
      }

      if (!OtorrinoEvalua && EvaluadoOtorrino == "1") {
        toast.error("Nombre Otorrino: Campo obligatorio *");
        isvalid_setOtorrinoEvalua(true);
        return null;
      }

      if (EvaluadoTerapiaLenguaje == null || EvaluadoTerapiaLenguaje == undefined) {
        toast.error("¿Ha sido evaluado en Terapia de Lenguaje?: Campo obligatorio *");
        isvalid_setEvaluadoTerapiaLenguaje(true);
        return null;
      }

      if (!TerapeutaEvalua && EvaluadoTerapiaLenguaje == "1") {
        toast.error("Nombre Terapeuta: Campo obligatorio *");
        isvalid_setTerapeutaEvalua(true);
        return null;
      }

      if (!FechaPerdidaAuditiva) {
        toast.error("Fecha en que se identificó la pérdida auditiva: Campo obligatorio *");
        isvalid_setFechaPerdidaAuditiva(true);
        return null;
      }

      if (!TiempoInicioPerdidaAud) {
        toast.error("Tiempo de inicio (meses): Campo obligatorio *");
        isvalid_setTiempoInicioPerdidaAud(true);
        return null;
      }

      if (!ProfQueDiagnostico) {
        toast.error("Centro, Institución o Profesional que lo diagnosticaron: Campo obligatorio *");
        isvalid_setProfQueDiagnostico(true);
        return null;
      }

      if (!CausaPerdidaAuditiva) {
        toast.error("¿Cuál fue la causa de la pérdida auditiva?: Campo obligatorio *");
        isvalid_setCausaPerdidaAuditiva(true);
        return null;
      }

      if (IdTipoPerdidaAuditiva == null) {
        toast.error("Tipo de Pérdida: Campo obligatorio *");
        isvalid_setIdTipoPerdidaAuditiva(true);
        return null;
      }

      if (!GradoHipoacusia) {
        toast.error("Grado de Hipoacusia: Campo obligatorio *");
        isvalid_setGradoHipoacusia(true);
        return null;
      }

      if (TieneEstudiosAudicion == null || TieneEstudiosAudicion == undefined) {
        toast.error("¿Tiene estudios de audición?: Campo obligatorio *");
        isvalid_setTieneEstudiosAudicion(true);
        return null;
      }

      if (!EstudiosAudicion && TieneEstudiosAudicion == "1") {
        toast.error("¿Cuáles?: Campo obligatorio *");
        isvalid_setEstudiosAudicion(true);
        return null;
      }

      if (!DiagnosticoAudicion && TieneEstudiosAudicion == "1") {
        toast.error("¿Cuál fue el diagnóstico?: Campo obligatorio *");
        isvalid_setDiagnosticoAudicion(true);
        return null;
      }

      if (UtilizaAuxAuditivos == null || UtilizaAuxAuditivos == undefined) {
        toast.error("¿Utiliza auxiliares auditivos?: Campo obligatorio *");
        isvalid_setUtilizaAuxAuditivos(true);
        return null;
      }

      if (!MarcaAuxAuditivos && UtilizaAuxAuditivos == "1") {
        toast.error("Marca y Modelo: Campo obligatorio *");
        isvalid_setMarcaAuxAuditivos(true);
        return null;
      }

      /* if (!FechaAdaptacionAuxAud) {
        toast.error("Fecha de la 1a adaptación de auxiliares auditivos: Campo obligatorio *");
        isvalid_setFechaAdaptacionAuxAud(true);
        return null;
        }*/

      if (HaAjustadoAuxAuditivos == null || HaAjustadoAuxAuditivos == undefined) {
        toast.error("¿Le han ajustado auxiliares auditivos?: Campo obligatorio *");
        isvalid_setHaAjustadoAuxAuditivos(true);
        return null;
      }

      if (!FechaAjusteAuxAuditivos && HaAjustadoAuxAuditivos?.value == "1") {
        toast.error("¿Cuándo?: Campo obligatorio *");
        isvalid_setFechaAjusteAuxAuditivos(true);
        return null;
      }

      if (!AudiologoAjuste && HaAjustadoAuxAuditivos?.value == "1") {
        toast.error("Nombre del Audiólogo que los ajustó: Campo obligatorio *");
        isvalid_setAudiologoAjuste(true);
        return null;
      }

      if (HaRecibidoTerapiaAudVerbal == null || HaRecibidoTerapiaAudVerbal == undefined) {
        toast.error("¿Ha recibido Terapia Auditiva-Verbal?: Campo obligatorio *");
        isvalid_setHaRecibidoTerapiaAudVerbal(true);
        return null;
      }

      if (!TerapiaAudVerbalQuien && HaRecibidoTerapiaAudVerbal?.value == "1") {
        toast.error("¿Con Quién?: Campo obligatorio *");
        isvalid_setTerapiaAudVerbalQuien(true);
        return null;
      }

      if (!ProgresosObtenidos && HaRecibidoTerapiaAudVerbal?.value == "1") {
        toast.error("Progresos obtenidos: Campo obligatorio *");
        isvalid_setProgresosObtenidos(true);
        return null;
      }

      /* if (!LenguajeActual) {
        toast.error("Describa su lenguaje actualmente: Campo obligatorio *");
        isvalid_setLenguajeActual(true);
        return null;
        }

        if (!EscuchaActualmente) {
        toast.error("¿Qué escucha y entiende actualmente?: Campo obligatorio *");
        isvalid_setEscuchaActualmente(true);
        return null;
        }

        if (!TieneEvaluacionVista) {
        toast.error("¿Ha sido evaluado de la vista?: Campo obligatorio *");
        isvalid_setTieneEvaluacionVista(true);
        return null;
        }*/

      if (TieneRetrasoDesarrollo == null || TieneRetrasoDesarrollo == undefined) {
        toast.error("¿Algún retraso en el desarrollo?: Campo obligatorio *");
        isvalid_setTieneRetrasoDesarrollo(true);
        return null;
      }

      if (!CualRetraso && TieneRetrasoDesarrollo?.value == "1") {
        toast.error("¿Cuál?: Campo obligatorio *");
        isvalid_setCualRetraso(true);
        return null;
      }
      const valoresIniciales = {
        idiomaMadre: IdiomaMadre,
        idiomaPadre: IdiomaPadre,
        idiomaEnCasa: IdiomaEnCasa,
        evaluadoAudiologia: EvaluadoAudiologia,
        audiologoEvalua: AudiologoEvalua,
        evaluadoOtorrino: EvaluadoOtorrino,
        otorrinoEvalua: OtorrinoEvalua,
        evaluadoTerapiaLenguaje: EvaluadoTerapiaLenguaje,
        terapeutaEvalua: TerapeutaEvalua,
        fechaPerdidaAuditiva: FechaPerdidaAuditiva,
        tiempoInicioPerdidaAud: TiempoInicioPerdidaAud,
        profQueDiagnostico: ProfQueDiagnostico,
        causaPerdidaAuditiva: CausaPerdidaAuditiva,
        idTipoPerdidaAuditiva: IdTipoPerdidaAuditiva,
        gradoHipoacusia: GradoHipoacusia,
        tieneEstudiosAudicion: TieneEstudiosAudicion,
        estudiosAudicion: EstudiosAudicion,
        diagnosticoAudicion: DiagnosticoAudicion,
        utilizaAuxAuditivos: UtilizaAuxAuditivos,
        marcaAuxAuditivos: MarcaAuxAuditivos,
        fechaAdaptacionAuxiliaresAud: FechaAdaptacionAuxAud,
        haAjustadoAuxAuditivos: HaAjustadoAuxAuditivos,
        fechaAjusteAuxAuditivos: FechaAjusteAuxAuditivos,
        audiologoAjuste: AudiologoAjuste,
        haRecibidoTerapiaAudVerbal: HaRecibidoTerapiaAudVerbal,
        terapiaAudVerbalQuien: TerapiaAudVerbalQuien,
        progresosObtenidos: ProgresosObtenidos,
        lenguajeActual: LenguajeActual,
        escuchaActualmente: EscuchaActualmente,
        tieneEvaluacionVista: TieneEvaluacionVista,
        tieneRetrasoDesarrollo: TieneRetrasoDesarrollo,
        cualRetraso: CualRetraso,
      };
      Next(valoresIniciales);
      return valoresIniciales;
    };

    //Métodos para guardar los datos editados:
    useImperativeHandle(ref, () => ({
      ejecutarNext: () => {
        return ValidaForm();
      },
    }));

    const handleBack = () => {
      const data = {
        idiomaMadre: IdiomaMadre,
        idiomaPadre: IdiomaPadre,
        idiomaEnCasa: IdiomaEnCasa,
        evaluadoAudiologia: EvaluadoAudiologia,
        audiologoEvalua: AudiologoEvalua,
        evaluadoOtorrino: EvaluadoOtorrino,
        otorrinoEvalua: OtorrinoEvalua,
        evaluadoTerapiaLenguaje: EvaluadoTerapiaLenguaje,
        terapeutaEvalua: TerapeutaEvalua,
        fechaPerdidaAuditiva: FechaPerdidaAuditiva,
        tiempoInicioPerdidaAud: TiempoInicioPerdidaAud,
        profQueDiagnostico: ProfQueDiagnostico,
        causaPerdidaAuditiva: CausaPerdidaAuditiva,
        idTipoPerdidaAuditiva: IdTipoPerdidaAuditiva,
        gradoHipoacusia: GradoHipoacusia,
        tieneEstudiosAudicion: TieneEstudiosAudicion,
        estudiosAudicion: EstudiosAudicion,
        diagnosticoAudicion: DiagnosticoAudicion,
        utilizaAuxAuditivos: UtilizaAuxAuditivos,
        marcaAuxAuditivos: MarcaAuxAuditivos,
        fechaAdaptacionAuxiliaresAud: FechaAdaptacionAuxAud,
        haAjustadoAuxAuditivos: HaAjustadoAuxAuditivos,
        fechaAjusteAuxAuditivos: FechaAjusteAuxAuditivos,
        audiologoAjuste: AudiologoAjuste,
        haRecibidoTerapiaAudVerbal: HaRecibidoTerapiaAudVerbal,
        terapiaAudVerbalQuien: TerapiaAudVerbalQuien,
        progresosObtenidos: ProgresosObtenidos,
        lenguajeActual: LenguajeActual,
        escuchaActualmente: EscuchaActualmente,
        tieneEvaluacionVista: TieneEvaluacionVista,
        tieneRetrasoDesarrollo: TieneRetrasoDesarrollo,
        cualRetraso: CualRetraso,
      };

      Back(data);
    };

    return (
      <>
        {/* Idioma de la Madre */}
        <Grid container spacing={2}>
          <Grid item xs={12} md={3} lg={3}>
            <MDBox textAlign="right">
              <MDTypography variant="h6" color="white" style={{ opacity: 0.7, fontSize: "0.9rem" }}>
                Idiomas
              </MDTypography>
            </MDBox>
          </Grid>
          <Grid item xs={12} md={9} lg={9}>
            <Grid container spacing={4}>
              <Grid item xs={12} md={4} lg={4}>
                <TextField
                  fullWidth
                  variant="outlined"
                  label="Idioma de la Madre"
                  autoComplete="off"
                  disabled={desactivar}
                  value={IdiomaMadre}
                  onChange={(e) => setIdiomaMadre(e.target.value)}
                  error={isvalid_IdiomaMadre}
                  helperText={isvalid_IdiomaMadre ? "Campo obligatorio *" : ""}
                  onFocus={() => isvalid_setIdiomaMadre(false)}
                  onBlur={() => {
                    if (!IdiomaMadre) isvalid_setIdiomaMadre(true);
                  }}
                  size="small"
                  style={{ marginBottom: "1rem" }}
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
              <Grid item xs={12} md={4} lg={4}>
                <TextField
                  fullWidth
                  variant="outlined"
                  label="Idioma del Padre"
                  autoComplete="off"
                  disabled={desactivar}
                  value={IdiomaPadre}
                  onChange={(e) => setIdiomaPadre(e.target.value)}
                  error={isvalid_IdiomaPadre}
                  helperText={isvalid_IdiomaPadre ? "Campo obligatorio *" : ""}
                  onFocus={() => {
                    isvalid_setIdiomaPadre(false);
                    if (!IdiomaMadre) {
                      isvalid_setIdiomaMadre(true);
                    }
                  }}
                  onBlur={() => {
                    if (!IdiomaPadre) isvalid_setIdiomaPadre(true);
                  }}
                  size="small"
                  style={{ marginBottom: "1rem" }}
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
              <Grid item xs={12} md={4} lg={4}>
                <TextField
                  fullWidth
                  variant="outlined"
                  label="Idioma de Casa"
                  autoComplete="off"
                  disabled={desactivar}
                  value={IdiomaEnCasa}
                  onChange={(e) => setIdiomaEnCasa(e.target.value)}
                  error={isvalid_IdiomaEnCasa}
                  helperText={isvalid_IdiomaEnCasa ? "Campo obligatorio *" : ""}
                  onFocus={() => {
                    isvalid_setIdiomaEnCasa(false);
                    if (!IdiomaMadre) {
                      isvalid_setIdiomaMadre(true);
                    }
                    if (!IdiomaPadre) {
                      isvalid_setIdiomaPadre(true);
                    }
                  }}
                  onBlur={() => {
                    if (!IdiomaEnCasa) isvalid_setIdiomaEnCasa(true);
                  }}
                  size="small"
                  style={{ marginBottom: "1rem" }}
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        <Grid container spacing={2}>
          {/* Evaluado por Audiólogo */}
          <Grid item xs={12} md={3} lg={3}>
            <MDBox textAlign="right">
              <MDTypography variant="h6" color="white" style={{ opacity: 0.7, fontSize: "0.9rem" }}>
                ¿Ha sido evaluado por un Audiólogo?
              </MDTypography>
            </MDBox>
          </Grid>
          <Grid item xs={12} md={9} lg={9}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={4} lg={4}>
                <Autocomplete
                  options={[
                    { label: "Sí", value: "1" },
                    { label: "No", value: "0" },
                  ]}
                  getOptionLabel={(option) => option.label}
                  disabled={desactivar}
                  id="EvaluadoAudiologia"
                  value={
                    [
                      { label: "Sí", value: "1" },
                      { label: "No", value: "0" },
                    ].find((opt) => opt.value == EvaluadoAudiologia) || null
                  }
                  onChange={(event, newValue) => {
                    setEvaluadoAudiologia(newValue ? newValue.value : null);
                    if (newValue != null && newValue.value == "1") {
                      isvalid_setAudiologoEvalua(true);
                    } else {
                      isvalid_setAudiologoEvalua(false);
                      setAudiologoEvalua("");
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      autoComplete="new-password"
                      label="Seleccione"
                      variant="outlined"
                      error={isvalid_EvaluadoAudiologia}
                      helperText={isvalid_EvaluadoAudiologia ? "Campo obligatorio *" : ""}
                      onFocus={() => {
                        isvalid_setEvaluadoAudiologia(false);
                        if (!IdiomaMadre) {
                          isvalid_setIdiomaMadre(true);
                        }
                        if (!IdiomaPadre) {
                          isvalid_setIdiomaPadre(true);
                        }
                        if (!IdiomaEnCasa) {
                          isvalid_setIdiomaEnCasa(true);
                        }
                      }}
                      onBlur={() => {
                        if (EvaluadoAudiologia == null) isvalid_setEvaluadoAudiologia(true);
                      }}
                    />
                  )}
                  style={{ width: "100%", marginBottom: "1rem" }}
                  size="small"
                />
              </Grid>
              <Grid item xs={12} md={2} lg={2}>
                <MDBox textAlign="right">
                  <MDTypography
                    variant="h6"
                    color="white"
                    style={{ opacity: 0.7, fontSize: "0.9rem" }}
                  >
                    Nombre Audiólogo:
                  </MDTypography>
                </MDBox>
              </Grid>
              <Grid item xs={12} md={6} lg={6}>
                <TextField
                  fullWidth
                  variant="outlined"
                  label="Especifique"
                  autoComplete="off"
                  disabled={desactivar}
                  value={AudiologoEvalua}
                  error={isvalid_AudiologoEvalua}
                  helperText={isvalid_AudiologoEvalua ? "Campo obligatorio *" : ""}
                  onChange={(e) => {
                    if (EvaluadoAudiologia != null && EvaluadoAudiologia == "1") {
                      setAudiologoEvalua(e.target.value);
                    }
                  }}
                  onFocus={() => {
                    isvalid_setAudiologoEvalua(false);
                    if (!IdiomaMadre) {
                      isvalid_setIdiomaMadre(true);
                    }
                    if (!IdiomaPadre) {
                      isvalid_setIdiomaPadre(true);
                    }
                    if (!IdiomaEnCasa) {
                      isvalid_setIdiomaEnCasa(true);
                    }
                    if (EvaluadoAudiologia == null) {
                      isvalid_setEvaluadoAudiologia(true);
                    }
                  }}
                  onBlur={() => {
                    if (
                      !AudiologoEvalua &&
                      EvaluadoAudiologia != null &&
                      EvaluadoAudiologia == "1"
                    ) {
                      isvalid_setAudiologoEvalua(true);
                    }
                  }}
                  size="small"
                  style={{ marginBottom: "1rem" }}
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
            </Grid>
          </Grid>

          {/* Evaluado por Otorrino */}
          <Grid item xs={12} md={3} lg={3}>
            <MDBox textAlign="right">
              <MDTypography variant="h6" color="white" style={{ opacity: 0.7, fontSize: "0.9rem" }}>
                ¿Ha sido evaluado por un Otorrino?
              </MDTypography>
            </MDBox>
          </Grid>
          <Grid item xs={12} md={9} lg={9}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={4} lg={4}>
                <Autocomplete
                  options={[
                    { label: "Sí", value: "1" },
                    { label: "No", value: "0" },
                  ]}
                  getOptionLabel={(option) => option.label}
                  disabled={desactivar}
                  id="EvaluadoOtorrino"
                  value={
                    [
                      { label: "Sí", value: "1" },
                      { label: "No", value: "0" },
                    ].find((opt) => opt.value == EvaluadoOtorrino) || null
                  }
                  onChange={(event, newValue) => {
                    setEvaluadoOtorrino(newValue ? newValue.value : null);
                    if (newValue != null && newValue.value == "1") {
                      isvalid_setOtorrinoEvalua(true);
                    } else {
                      isvalid_setOtorrinoEvalua(false);
                      setOtorrinoEvalua("");
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      autoComplete="new-password"
                      label="Seleccione"
                      variant="outlined"
                      error={isvalid_EvaluadoOtorrino}
                      helperText={isvalid_EvaluadoOtorrino ? "Campo obligatorio *" : ""}
                      onFocus={() => {
                        isvalid_setEvaluadoOtorrino(false);
                        if (!IdiomaMadre) {
                          isvalid_setIdiomaMadre(true);
                        }
                        if (!IdiomaPadre) {
                          isvalid_setIdiomaPadre(true);
                        }
                        if (!IdiomaEnCasa) {
                          isvalid_setIdiomaEnCasa(true);
                        }
                        if (EvaluadoAudiologia == null) {
                          isvalid_setEvaluadoAudiologia(true);
                        }
                        if (!AudiologoEvalua && EvaluadoAudiologia == 1) {
                          isvalid_setAudiologoEvalua(true);
                        }
                      }}
                      onBlur={() => {
                        if (EvaluadoOtorrino == null) isvalid_setEvaluadoOtorrino(true);
                      }}
                    />
                  )}
                  style={{ width: "100%", marginBottom: "1rem" }}
                  size="small"
                />
              </Grid>
              <Grid item xs={12} md={2} lg={2}>
                <MDBox textAlign="right">
                  <MDTypography
                    variant="h6"
                    color="white"
                    style={{ opacity: 0.7, fontSize: "0.9rem" }}
                  >
                    Nombre Otorrino:
                  </MDTypography>
                </MDBox>
              </Grid>
              <Grid item xs={12} md={6} lg={6}>
                <TextField
                  fullWidth
                  variant="outlined"
                  label="Especifique"
                  autoComplete="off"
                  disabled={desactivar}
                  value={OtorrinoEvalua}
                  error={isvalid_OtorrinoEvalua}
                  helperText={isvalid_OtorrinoEvalua ? "Campo obligatorio *" : ""}
                  onFocus={() => {
                    isvalid_setOtorrinoEvalua(false);
                    if (!IdiomaMadre) {
                      isvalid_setIdiomaMadre(true);
                    }
                    if (!IdiomaPadre) {
                      isvalid_setIdiomaPadre(true);
                    }
                    if (!IdiomaEnCasa) {
                      isvalid_setIdiomaEnCasa(true);
                    }
                    if (EvaluadoAudiologia == null) {
                      isvalid_setEvaluadoAudiologia(true);
                    }
                    if (!AudiologoEvalua && EvaluadoAudiologia == 1) {
                      isvalid_setAudiologoEvalua(true);
                    }
                    if (EvaluadoOtorrino == null) {
                      isvalid_setEvaluadoOtorrino(true);
                    }
                  }}
                  onChange={(e) => {
                    if (EvaluadoOtorrino != null && EvaluadoOtorrino == "1") {
                      setOtorrinoEvalua(e.target.value);
                    }
                  }}
                  onBlur={() => {
                    if (!OtorrinoEvalua && EvaluadoOtorrino != null && EvaluadoOtorrino == "1") {
                      isvalid_setOtorrinoEvalua(true);
                    }
                  }}
                  size="small"
                  style={{ marginBottom: "1rem" }}
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
            </Grid>
          </Grid>

          {/* Evaluado en Terapia de Lenguaje */}
          <Grid item xs={12} md={3} lg={3}>
            <MDBox textAlign="right">
              <MDTypography variant="h6" color="white" style={{ opacity: 0.7, fontSize: "0.9rem" }}>
                ¿Ha sido evaluado en Terapia de Lenguaje?
              </MDTypography>
            </MDBox>
          </Grid>
          <Grid item xs={12} md={9} lg={9}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={4} lg={4}>
                <Autocomplete
                  options={[
                    { label: "Sí", value: "1" },
                    { label: "No", value: "0" },
                  ]}
                  getOptionLabel={(option) => option.label}
                  disabled={desactivar}
                  id="EvaluadoTerapiaLenguaje"
                  value={
                    [
                      { label: "Sí", value: "1" },
                      { label: "No", value: "0" },
                    ].find((opt) => opt.value == EvaluadoTerapiaLenguaje) || null
                  }
                  onChange={(event, newValue) => {
                    setEvaluadoTerapiaLenguaje(newValue ? newValue.value : null);
                    if (newValue != null && newValue.value == "1") {
                      isvalid_setTerapeutaEvalua(true);
                    } else {
                      isvalid_setTerapeutaEvalua(false);
                      setTerapeutaEvalua("");
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      autoComplete="new-password"
                      label="Seleccione"
                      variant="outlined"
                      error={isvalid_EvaluadoTerapiaLenguaje}
                      helperText={isvalid_EvaluadoTerapiaLenguaje ? "Campo obligatorio *" : ""}
                      onFocus={() => {
                        isvalid_setEvaluadoTerapiaLenguaje(false);
                        if (!IdiomaMadre) {
                          isvalid_setIdiomaMadre(true);
                        }
                        if (!IdiomaPadre) {
                          isvalid_setIdiomaPadre(true);
                        }
                        if (!IdiomaEnCasa) {
                          isvalid_setIdiomaEnCasa(true);
                        }
                        if (EvaluadoAudiologia == null) {
                          isvalid_setEvaluadoAudiologia(true);
                        }
                        if (!AudiologoEvalua && EvaluadoAudiologia == 1) {
                          isvalid_setAudiologoEvalua(true);
                        }
                        if (EvaluadoOtorrino == null) {
                          isvalid_setEvaluadoOtorrino(true);
                        }
                        if (!OtorrinoEvalua && EvaluadoOtorrino == 1) {
                          isvalid_setOtorrinoEvalua(true);
                        }
                      }}
                      onBlur={() => {
                        if (EvaluadoTerapiaLenguaje == null)
                          isvalid_setEvaluadoTerapiaLenguaje(true);
                      }}
                    />
                  )}
                  style={{ width: "100%", marginBottom: "1rem" }}
                  size="small"
                />
              </Grid>
              <Grid item xs={12} md={2} lg={2}>
                <MDBox textAlign="right">
                  <MDTypography
                    variant="h6"
                    color="white"
                    style={{ opacity: 0.7, fontSize: "0.9rem" }}
                  >
                    Nombre Terapeuta:
                  </MDTypography>
                </MDBox>
              </Grid>
              <Grid item xs={12} md={6} lg={6}>
                <TextField
                  fullWidth
                  variant="outlined"
                  label="Especifique"
                  autoComplete="off"
                  disabled={desactivar}
                  value={TerapeutaEvalua}
                  error={isvalid_TerapeutaEvalua}
                  helperText={isvalid_TerapeutaEvalua ? "Campo obligatorio *" : ""}
                  onFocus={() => {
                    isvalid_setTerapeutaEvalua(false);
                    if (!IdiomaMadre) {
                      isvalid_setIdiomaMadre(true);
                    }
                    if (!IdiomaPadre) {
                      isvalid_setIdiomaPadre(true);
                    }
                    if (!IdiomaEnCasa) {
                      isvalid_setIdiomaEnCasa(true);
                    }
                    if (EvaluadoAudiologia == null) {
                      isvalid_setEvaluadoAudiologia(true);
                    }
                    if (!AudiologoEvalua && EvaluadoAudiologia == 1) {
                      isvalid_setAudiologoEvalua(true);
                    }
                    if (EvaluadoOtorrino == null) {
                      isvalid_setEvaluadoOtorrino(true);
                    }
                    if (!OtorrinoEvalua && EvaluadoOtorrino == 1) {
                      isvalid_setOtorrinoEvalua(true);
                    }
                    if (EvaluadoTerapiaLenguaje == null) {
                      isvalid_setEvaluadoTerapiaLenguaje(true);
                    }
                  }}
                  onChange={(e) => {
                    if (EvaluadoTerapiaLenguaje != null && EvaluadoTerapiaLenguaje == "1") {
                      setTerapeutaEvalua(e.target.value);
                    }
                  }}
                  onBlur={() => {
                    if (
                      !TerapeutaEvalua &&
                      EvaluadoTerapiaLenguaje != null &&
                      EvaluadoTerapiaLenguaje == "1"
                    ) {
                      isvalid_setTerapeutaEvalua(true);
                    }
                  }}
                  size="small"
                  style={{ marginBottom: "1rem" }}
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
            </Grid>
          </Grid>

          {/* Fecha y tiempo de pérdida auditiva */}
          <Grid item xs={12} md={3} lg={3}>
            <MDBox textAlign="right">
              <MDTypography variant="h6" color="white" style={{ opacity: 0.7, fontSize: "0.9rem" }}>
                Fecha en que se identificó la pérdida auditiva:
              </MDTypography>
            </MDBox>
          </Grid>
          <Grid item xs={12} md={9} lg={9}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={6} lg={6}>
                <TextField
                  fullWidth
                  type={desactivar ? "text" : "date"}
                  variant="outlined"
                  value={FechaPerdidaAuditiva}
                  onChange={(e) => setFechaPerdidaAuditiva(e.target.value)}
                  error={isvalid_FechaPerdidaAuditiva}
                  helperText={isvalid_FechaPerdidaAuditiva ? "Campo obligatorio *" : ""}
                  onFocus={() => {
                    isvalid_setFechaPerdidaAuditiva(false);
                    if (!IdiomaMadre) {
                      isvalid_setIdiomaMadre(true);
                    }
                    if (!IdiomaPadre) {
                      isvalid_setIdiomaPadre(true);
                    }
                    if (!IdiomaEnCasa) {
                      isvalid_setIdiomaEnCasa(true);
                    }
                    if (EvaluadoAudiologia == null) {
                      isvalid_setEvaluadoAudiologia(true);
                    }
                    if (!AudiologoEvalua && EvaluadoAudiologia == 1) {
                      isvalid_setAudiologoEvalua(true);
                    }
                    if (EvaluadoOtorrino == null) {
                      isvalid_setEvaluadoOtorrino(true);
                    }
                    if (!OtorrinoEvalua && EvaluadoOtorrino == 1) {
                      isvalid_setOtorrinoEvalua(true);
                    }
                    if (EvaluadoTerapiaLenguaje == null) {
                      isvalid_setEvaluadoTerapiaLenguaje(true);
                    }
                    if (!TerapeutaEvalua && EvaluadoTerapiaLenguaje == 1) {
                      isvalid_setTerapeutaEvalua(true);
                    }
                  }}
                  onBlur={() => {
                    if (!FechaPerdidaAuditiva) isvalid_setFechaPerdidaAuditiva(true);
                  }}
                  size="small"
                  InputLabelProps={{ shrink: true }}
                  onKeyDown={(e) => e.preventDefault()}
                  onPaste={(e) => e.preventDefault()}
                  autoComplete="off"
                  disabled={desactivar}
                  inputProps={{
                    max: moment().format("YYYY-MM-DD"),
                  }}
                  onClick={(e) => {
                    e.target.showPicker && e.target.showPicker();
                  }}
                  style={{ marginBottom: "1.5rem", cursor: "pointer" }}
                />
              </Grid>
              <Grid item xs={12} md={6} lg={6}>
                <TextField
                  fullWidth
                  variant="outlined"
                  label="Tiempo de inicio (meses)"
                  autoComplete="off"
                  disabled={desactivar}
                  value={TiempoInicioPerdidaAud}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (/^\d*$/.test(value)) {
                      setTiempoInicioPerdidaAud(value);
                    }
                  }}
                  error={isvalid_TiempoInicioPerdidaAud}
                  helperText={isvalid_TiempoInicioPerdidaAud ? "Campo obligatorio *" : ""}
                  onFocus={() => {
                    isvalid_setTiempoInicioPerdidaAud(false);
                    if (!IdiomaMadre) {
                      isvalid_setIdiomaMadre(true);
                    }
                    if (!IdiomaPadre) {
                      isvalid_setIdiomaPadre(true);
                    }
                    if (!IdiomaEnCasa) {
                      isvalid_setIdiomaEnCasa(true);
                    }
                    if (EvaluadoAudiologia == null) {
                      isvalid_setEvaluadoAudiologia(true);
                    }
                    if (!AudiologoEvalua && EvaluadoAudiologia == 1) {
                      isvalid_setAudiologoEvalua(true);
                    }
                    if (EvaluadoOtorrino == null) {
                      isvalid_setEvaluadoOtorrino(true);
                    }
                    if (!OtorrinoEvalua && EvaluadoOtorrino == 1) {
                      isvalid_setOtorrinoEvalua(true);
                    }
                    if (EvaluadoTerapiaLenguaje == null) {
                      isvalid_setEvaluadoTerapiaLenguaje(true);
                    }
                    if (!TerapeutaEvalua && EvaluadoTerapiaLenguaje == 1) {
                      isvalid_setTerapeutaEvalua(true);
                    }
                    if (!FechaPerdidaAuditiva) {
                      isvalid_setFechaPerdidaAuditiva(true);
                    }
                  }}
                  onBlur={() => {
                    if (!TiempoInicioPerdidaAud) isvalid_setTiempoInicioPerdidaAud(true);
                  }}
                  size="small"
                  inputProps={{
                    inputMode: "numeric", // Muestra teclado numérico en móviles
                    pattern: "[0-9]*", // Sugiere sólo números
                  }}
                  style={{ marginBottom: "1rem" }}
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
            </Grid>
          </Grid>

          {/* Profesional o centro que diagnosticó */}
          <Grid item xs={12} md={3} lg={3}>
            <MDBox textAlign="right">
              <MDTypography variant="h6" color="white" style={{ opacity: 0.7, fontSize: "0.9rem" }}>
                Centro, Institución o Profesional que lo diagnosticaron:
              </MDTypography>
            </MDBox>
          </Grid>
          <Grid item xs={12} md={9} lg={9}>
            <TextField
              fullWidth
              variant="outlined"
              label="Especifique"
              autoComplete="off"
              disabled={desactivar}
              value={ProfQueDiagnostico}
              onChange={(e) => setProfQueDiagnostico(e.target.value)}
              error={isvalid_ProfQueDiagnostico}
              helperText={isvalid_ProfQueDiagnostico ? "Campo obligatorio *" : ""}
              onFocus={() => {
                isvalid_setProfQueDiagnostico(false);
                if (!IdiomaMadre) {
                  isvalid_setIdiomaMadre(true);
                }
                if (!IdiomaPadre) {
                  isvalid_setIdiomaPadre(true);
                }
                if (!IdiomaEnCasa) {
                  isvalid_setIdiomaEnCasa(true);
                }
                if (EvaluadoAudiologia == null) {
                  isvalid_setEvaluadoAudiologia(true);
                }
                if (!AudiologoEvalua && EvaluadoAudiologia == 1) {
                  isvalid_setAudiologoEvalua(true);
                }
                if (EvaluadoOtorrino == null) {
                  isvalid_setEvaluadoOtorrino(true);
                }
                if (!OtorrinoEvalua && EvaluadoOtorrino == 1) {
                  isvalid_setOtorrinoEvalua(true);
                }
                if (EvaluadoTerapiaLenguaje == null) {
                  isvalid_setEvaluadoTerapiaLenguaje(true);
                }
                if (!TerapeutaEvalua && EvaluadoTerapiaLenguaje == 1) {
                  isvalid_setTerapeutaEvalua(true);
                }
                if (!FechaPerdidaAuditiva) {
                  isvalid_setFechaPerdidaAuditiva(true);
                }
                if (!TiempoInicioPerdidaAud) {
                  isvalid_setTiempoInicioPerdidaAud(true);
                }
              }}
              onBlur={() => {
                if (!ProfQueDiagnostico) isvalid_setProfQueDiagnostico(true);
              }}
              size="small"
              style={{ marginBottom: "1rem" }}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>

          {/* Causa, tipo y grado de pérdida auditiva */}
          <Grid item xs={12} md={3} lg={3}>
            <MDBox textAlign="right">
              <MDTypography variant="h6" color="white" style={{ opacity: 0.7, fontSize: "0.9rem" }}>
                ¿Cuál fue la causa de la pérdida auditiva?
              </MDTypography>
            </MDBox>
          </Grid>
          <Grid item xs={12} md={9} lg={9}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={4} lg={4}>
                <TextField
                  fullWidth
                  variant="outlined"
                  label="Causa"
                  autoComplete="off"
                  disabled={desactivar}
                  value={CausaPerdidaAuditiva}
                  onChange={(e) => setCausaPerdidaAuditiva(e.target.value)}
                  error={isvalid_CausaPerdidaAuditiva}
                  helperText={isvalid_CausaPerdidaAuditiva ? "Campo obligatorio *" : ""}
                  onFocus={() => {
                    isvalid_setCausaPerdidaAuditiva(false);
                    if (!IdiomaMadre) {
                      isvalid_setIdiomaMadre(true);
                    }
                    if (!IdiomaPadre) {
                      isvalid_setIdiomaPadre(true);
                    }
                    if (!IdiomaEnCasa) {
                      isvalid_setIdiomaEnCasa(true);
                    }
                    if (EvaluadoAudiologia == null) {
                      isvalid_setEvaluadoAudiologia(true);
                    }
                    if (!AudiologoEvalua && EvaluadoAudiologia == 1) {
                      isvalid_setAudiologoEvalua(true);
                    }
                    if (EvaluadoOtorrino == null) {
                      isvalid_setEvaluadoOtorrino(true);
                    }
                    if (!OtorrinoEvalua && EvaluadoOtorrino == 1) {
                      isvalid_setOtorrinoEvalua(true);
                    }
                    if (EvaluadoTerapiaLenguaje == null) {
                      isvalid_setEvaluadoTerapiaLenguaje(true);
                    }
                    if (!TerapeutaEvalua && EvaluadoTerapiaLenguaje == 1) {
                      isvalid_setTerapeutaEvalua(true);
                    }
                    if (!FechaPerdidaAuditiva) {
                      isvalid_setFechaPerdidaAuditiva(true);
                    }
                    if (!TiempoInicioPerdidaAud) {
                      isvalid_setTiempoInicioPerdidaAud(true);
                    }
                    if (!ProfQueDiagnostico) {
                      isvalid_setProfQueDiagnostico(true);
                    }
                  }}
                  onBlur={() => {
                    if (!CausaPerdidaAuditiva) isvalid_setCausaPerdidaAuditiva(true);
                  }}
                  size="small"
                  style={{ marginBottom: "1rem" }}
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>

              <Grid item xs={12} md={4} lg={4}>
                <Autocomplete
                  options={[
                    { label: "En un oído", value: "1" },
                    { label: "En ambos oídos", value: "2" },
                  ]}
                  getOptionLabel={(option) => option.label}
                  disabled={desactivar}
                  id="IdTipoPerdidaAuditiva"
                  value={
                    [
                      { label: "En un oído", value: "1" },
                      { label: "En ambos oídos", value: "2" },
                    ].find((opt) => opt.value == IdTipoPerdidaAuditiva) || null
                  }
                  onChange={(e, newValue) =>
                    setIdTipoPerdidaAuditiva(newValue ? newValue.value : null)
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      autoComplete="new-password"
                      label="Tipo de Pérdida"
                      variant="outlined"
                      error={isvalid_IdTipoPerdidaAuditiva}
                      helperText={isvalid_IdTipoPerdidaAuditiva ? "Campo obligatorio *" : ""}
                      onFocus={() => {
                        isvalid_setIdTipoPerdidaAuditiva(false);
                        if (!IdiomaMadre) {
                          isvalid_setIdiomaMadre(true);
                        }
                        if (!IdiomaPadre) {
                          isvalid_setIdiomaPadre(true);
                        }
                        if (!IdiomaEnCasa) {
                          isvalid_setIdiomaEnCasa(true);
                        }
                        if (EvaluadoAudiologia == null) {
                          isvalid_setEvaluadoAudiologia(true);
                        }
                        if (!AudiologoEvalua && EvaluadoAudiologia == 1) {
                          isvalid_setAudiologoEvalua(true);
                        }
                        if (EvaluadoOtorrino == null) {
                          isvalid_setEvaluadoOtorrino(true);
                        }
                        if (!OtorrinoEvalua && EvaluadoOtorrino == 1) {
                          isvalid_setOtorrinoEvalua(true);
                        }
                        if (EvaluadoTerapiaLenguaje == null) {
                          isvalid_setEvaluadoTerapiaLenguaje(true);
                        }
                        if (!TerapeutaEvalua && EvaluadoTerapiaLenguaje == 1) {
                          isvalid_setTerapeutaEvalua(true);
                        }
                        if (!FechaPerdidaAuditiva) {
                          isvalid_setFechaPerdidaAuditiva(true);
                        }
                        if (!TiempoInicioPerdidaAud) {
                          isvalid_setTiempoInicioPerdidaAud(true);
                        }
                        if (!ProfQueDiagnostico) {
                          isvalid_setProfQueDiagnostico(true);
                        }
                        if (!CausaPerdidaAuditiva) {
                          isvalid_setCausaPerdidaAuditiva(true);
                        }
                      }}
                      onBlur={() => {
                        if (IdTipoPerdidaAuditiva == null) isvalid_setIdTipoPerdidaAuditiva(true);
                      }}
                    />
                  )}
                  size="small"
                  style={{ width: "100%", marginBottom: "1rem" }}
                />
              </Grid>
              <Grid item xs={12} md={4} lg={4}>
                <TextField
                  fullWidth
                  variant="outlined"
                  label="Grado de Hipoacusia"
                  autoComplete="off"
                  disabled={desactivar}
                  value={GradoHipoacusia}
                  onChange={(e) => setGradoHipoacusia(e.target.value)}
                  error={isvalid_GradoHipoacusia}
                  helperText={isvalid_GradoHipoacusia ? "Campo obligatorio *" : ""}
                  onFocus={() => {
                    isvalid_setGradoHipoacusia(false);
                    if (!IdiomaMadre) {
                      isvalid_setIdiomaMadre(true);
                    }
                    if (!IdiomaPadre) {
                      isvalid_setIdiomaPadre(true);
                    }
                    if (!IdiomaEnCasa) {
                      isvalid_setIdiomaEnCasa(true);
                    }
                    if (EvaluadoAudiologia == null) {
                      isvalid_setEvaluadoAudiologia(true);
                    }
                    if (!AudiologoEvalua && EvaluadoAudiologia == 1) {
                      isvalid_setAudiologoEvalua(true);
                    }
                    if (EvaluadoOtorrino == null) {
                      isvalid_setEvaluadoOtorrino(true);
                    }
                    if (!OtorrinoEvalua && EvaluadoOtorrino == 1) {
                      isvalid_setOtorrinoEvalua(true);
                    }
                    if (EvaluadoTerapiaLenguaje == null) {
                      isvalid_setEvaluadoTerapiaLenguaje(true);
                    }
                    if (!TerapeutaEvalua && EvaluadoTerapiaLenguaje == 1) {
                      isvalid_setTerapeutaEvalua(true);
                    }
                    if (!FechaPerdidaAuditiva) {
                      isvalid_setFechaPerdidaAuditiva(true);
                    }
                    if (!TiempoInicioPerdidaAud) {
                      isvalid_setTiempoInicioPerdidaAud(true);
                    }
                    if (!ProfQueDiagnostico) {
                      isvalid_setProfQueDiagnostico(true);
                    }
                    if (!CausaPerdidaAuditiva) {
                      isvalid_setCausaPerdidaAuditiva(true);
                    }
                    if (IdTipoPerdidaAuditiva == null) {
                      isvalid_setIdTipoPerdidaAuditiva(true);
                    }
                  }}
                  onBlur={() => {
                    if (!GradoHipoacusia) isvalid_setGradoHipoacusia(true);
                  }}
                  size="small"
                  style={{ marginBottom: "1rem" }}
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        <Grid container spacing={2}>
          {/* Tiene estudios de audición */}
          <Grid item xs={12} md={3} lg={3}>
            <MDBox textAlign="right">
              <MDTypography variant="h6" color="white" style={{ opacity: 0.7, fontSize: "0.9rem" }}>
                ¿Tiene estudios de audición?
              </MDTypography>
            </MDBox>
          </Grid>
          <Grid item xs={12} md={9} lg={9}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={4} lg={4}>
                <Autocomplete
                  options={[
                    { label: "Sí", value: "1" },
                    { label: "No", value: "0" },
                  ]}
                  getOptionLabel={(option) => option.label}
                  disabled={desactivar}
                  id="TieneEstudiosAudicion"
                  value={
                    [
                      { label: "Sí", value: "1" },
                      { label: "No", value: "0" },
                    ].find((opt) => opt.value == TieneEstudiosAudicion) || null
                  }
                  onChange={(event, newValue) => {
                    setTieneEstudiosAudicion(newValue ? newValue.value : null);
                    if (newValue != null && newValue.value == "1") {
                      isvalid_setEstudiosAudicion(true);
                      isvalid_setDiagnosticoAudicion(true);
                    } else {
                      isvalid_setEstudiosAudicion(false);
                      isvalid_setDiagnosticoAudicion(false);
                      setEstudiosAudicion("");
                      setDiagnosticoAudicion("");
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      autoComplete="new-password"
                      label="Seleccione"
                      variant="outlined"
                      error={isvalid_TieneEstudiosAudicion}
                      helperText={isvalid_TieneEstudiosAudicion ? "Campo obligatorio *" : ""}
                      onFocus={() => {
                        isvalid_setTieneEstudiosAudicion(false);
                        if (!IdiomaMadre) {
                          isvalid_setIdiomaMadre(true);
                        }
                        if (!IdiomaPadre) {
                          isvalid_setIdiomaPadre(true);
                        }
                        if (!IdiomaEnCasa) {
                          isvalid_setIdiomaEnCasa(true);
                        }
                        if (EvaluadoAudiologia == null) {
                          isvalid_setEvaluadoAudiologia(true);
                        }
                        if (!AudiologoEvalua && EvaluadoAudiologia == 1) {
                          isvalid_setAudiologoEvalua(true);
                        }
                        if (EvaluadoOtorrino == null) {
                          isvalid_setEvaluadoOtorrino(true);
                        }
                        if (!OtorrinoEvalua && EvaluadoOtorrino == 1) {
                          isvalid_setOtorrinoEvalua(true);
                        }
                        if (EvaluadoTerapiaLenguaje == null) {
                          isvalid_setEvaluadoTerapiaLenguaje(true);
                        }
                        if (!TerapeutaEvalua && EvaluadoTerapiaLenguaje == 1) {
                          isvalid_setTerapeutaEvalua(true);
                        }
                        if (!FechaPerdidaAuditiva) {
                          isvalid_setFechaPerdidaAuditiva(true);
                        }
                        if (!TiempoInicioPerdidaAud) {
                          isvalid_setTiempoInicioPerdidaAud(true);
                        }
                        if (!ProfQueDiagnostico) {
                          isvalid_setProfQueDiagnostico(true);
                        }
                        if (!CausaPerdidaAuditiva) {
                          isvalid_setCausaPerdidaAuditiva(true);
                        }
                        if (IdTipoPerdidaAuditiva == null) {
                          isvalid_setIdTipoPerdidaAuditiva(true);
                        }
                        if (!GradoHipoacusia) {
                          isvalid_setGradoHipoacusia(true);
                        }
                      }}
                      onBlur={() => {
                        if (TieneEstudiosAudicion == null) isvalid_setTieneEstudiosAudicion(true);
                      }}
                    />
                  )}
                  style={{ width: "100%", marginBottom: "1rem" }}
                  size="small"
                />
              </Grid>
              <Grid item xs={12} md={2} lg={2}>
                <MDBox textAlign="right">
                  <MDTypography
                    variant="h6"
                    color="white"
                    style={{ opacity: 0.7, fontSize: "0.9rem" }}
                  >
                    ¿Cuáles?
                  </MDTypography>
                </MDBox>
              </Grid>
              <Grid item xs={12} md={6} lg={6}>
                <TextField
                  fullWidth
                  variant="outlined"
                  label="Especifique"
                  autoComplete="off"
                  disabled={desactivar}
                  value={EstudiosAudicion}
                  error={isvalid_EstudiosAudicion}
                  helperText={isvalid_EstudiosAudicion ? "Campo obligatorio *" : ""}
                  onFocus={() => {
                    isvalid_setEstudiosAudicion(false);
                    if (!IdiomaMadre) {
                      isvalid_setIdiomaMadre(true);
                    }
                    if (!IdiomaPadre) {
                      isvalid_setIdiomaPadre(true);
                    }
                    if (!IdiomaEnCasa) {
                      isvalid_setIdiomaEnCasa(true);
                    }
                    if (EvaluadoAudiologia == null) {
                      isvalid_setEvaluadoAudiologia(true);
                    }
                    if (!AudiologoEvalua && EvaluadoAudiologia == 1) {
                      isvalid_setAudiologoEvalua(true);
                    }
                    if (EvaluadoOtorrino == null) {
                      isvalid_setEvaluadoOtorrino(true);
                    }
                    if (!OtorrinoEvalua && EvaluadoOtorrino == 1) {
                      isvalid_setOtorrinoEvalua(true);
                    }
                    if (EvaluadoTerapiaLenguaje == null) {
                      isvalid_setEvaluadoTerapiaLenguaje(true);
                    }
                    if (!TerapeutaEvalua && EvaluadoTerapiaLenguaje == 1) {
                      isvalid_setTerapeutaEvalua(true);
                    }
                    if (!FechaPerdidaAuditiva) {
                      isvalid_setFechaPerdidaAuditiva(true);
                    }
                    if (!TiempoInicioPerdidaAud) {
                      isvalid_setTiempoInicioPerdidaAud(true);
                    }
                    if (!ProfQueDiagnostico) {
                      isvalid_setProfQueDiagnostico(true);
                    }
                    if (!CausaPerdidaAuditiva) {
                      isvalid_setCausaPerdidaAuditiva(true);
                    }
                    if (IdTipoPerdidaAuditiva == null) {
                      isvalid_setIdTipoPerdidaAuditiva(true);
                    }
                    if (!GradoHipoacusia) {
                      isvalid_setGradoHipoacusia(true);
                    }
                    if (TieneEstudiosAudicion == null) {
                      isvalid_setTieneEstudiosAudicion(true);
                    }
                  }}
                  onChange={(e) => {
                    if (TieneEstudiosAudicion != null && TieneEstudiosAudicion == "1") {
                      setEstudiosAudicion(e.target.value);
                    }
                  }}
                  onBlur={() => {
                    if (
                      !EstudiosAudicion &&
                      TieneEstudiosAudicion != null &&
                      TieneEstudiosAudicion == "1"
                    ) {
                      isvalid_setEstudiosAudicion(true);
                    }
                  }}
                  size="small"
                  style={{ marginBottom: "1rem" }}
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
            </Grid>
          </Grid>

          {/* Diagnóstico */}
          <Grid item xs={12} md={3} lg={3}>
            <MDBox textAlign="right">
              <MDTypography variant="h6" color="white" style={{ opacity: 0.7, fontSize: "0.9rem" }}>
                ¿Cuál fue el diagnóstico?
              </MDTypography>
            </MDBox>
          </Grid>
          <Grid item xs={12} md={9} lg={9}>
            <TextField
              fullWidth
              variant="outlined"
              label="Diagnóstico"
              autoComplete="off"
              disabled={desactivar}
              value={DiagnosticoAudicion}
              error={isvalid_DiagnosticoAudicion}
              helperText={isvalid_DiagnosticoAudicion ? "Campo obligatorio *" : ""}
              onFocus={() => {
                isvalid_setDiagnosticoAudicion(false);
                if (!IdiomaMadre) {
                  isvalid_setIdiomaMadre(true);
                }
                if (!IdiomaPadre) {
                  isvalid_setIdiomaPadre(true);
                }
                if (!IdiomaEnCasa) {
                  isvalid_setIdiomaEnCasa(true);
                }
                if (EvaluadoAudiologia == null) {
                  isvalid_setEvaluadoAudiologia(true);
                }
                if (!AudiologoEvalua && EvaluadoAudiologia == 1) {
                  isvalid_setAudiologoEvalua(true);
                }
                if (EvaluadoOtorrino == null) {
                  isvalid_setEvaluadoOtorrino(true);
                }
                if (!OtorrinoEvalua && EvaluadoOtorrino == 1) {
                  isvalid_setOtorrinoEvalua(true);
                }
                if (EvaluadoTerapiaLenguaje == null) {
                  isvalid_setEvaluadoTerapiaLenguaje(true);
                }
                if (!TerapeutaEvalua && EvaluadoTerapiaLenguaje == 1) {
                  isvalid_setTerapeutaEvalua(true);
                }
                if (!FechaPerdidaAuditiva) {
                  isvalid_setFechaPerdidaAuditiva(true);
                }
                if (!TiempoInicioPerdidaAud) {
                  isvalid_setTiempoInicioPerdidaAud(true);
                }
                if (!ProfQueDiagnostico) {
                  isvalid_setProfQueDiagnostico(true);
                }
                if (!CausaPerdidaAuditiva) {
                  isvalid_setCausaPerdidaAuditiva(true);
                }
                if (IdTipoPerdidaAuditiva == null) {
                  isvalid_setIdTipoPerdidaAuditiva(true);
                }
                if (!GradoHipoacusia) {
                  isvalid_setGradoHipoacusia(true);
                }
                if (TieneEstudiosAudicion == null) {
                  isvalid_setTieneEstudiosAudicion(true);
                }
                if (!EstudiosAudicion && TieneEstudiosAudicion == 1) {
                  isvalid_setEstudiosAudicion(true);
                }
              }}
              onChange={(e) => {
                if (TieneEstudiosAudicion != null && TieneEstudiosAudicion == "1") {
                  setDiagnosticoAudicion(e.target.value);
                }
              }}
              onBlur={() => {
                if (
                  !DiagnosticoAudicion &&
                  TieneEstudiosAudicion != null &&
                  TieneEstudiosAudicion == "1"
                ) {
                  isvalid_setDiagnosticoAudicion(true);
                }
              }}
              size="small"
              style={{ marginBottom: "1rem" }}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>

          {/* Utiliza auxiliares auditivos */}
          <Grid item xs={12} md={3} lg={3}>
            <MDBox textAlign="right">
              <MDTypography variant="h6" color="white" style={{ opacity: 0.7, fontSize: "0.9rem" }}>
                ¿Utiliza auxiliares auditivos?
              </MDTypography>
            </MDBox>
          </Grid>
          <Grid item xs={12} md={9} lg={9}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={4} lg={4}>
                <Autocomplete
                  options={[
                    { label: "Sí", value: "1" },
                    { label: "No", value: "0" },
                  ]}
                  getOptionLabel={(option) => option.label}
                  disabled={desactivar}
                  id="UtilizaAuxAuditivos"
                  value={
                    [
                      { label: "Sí", value: "1" },
                      { label: "No", value: "0" },
                    ].find((opt) => opt.value == UtilizaAuxAuditivos) || null
                  }
                  onChange={(event, newValue) => {
                    setUtilizaAuxAuditivos(newValue ? newValue.value : null);
                    if (newValue != null && newValue.value == "1") {
                      isvalid_setMarcaAuxAuditivos(true);
                      isvalid_setFechaAdaptacionAuxAud(true);
                    } else {
                      isvalid_setMarcaAuxAuditivos(false);
                      isvalid_setFechaAdaptacionAuxAud(false);
                      setMarcaAuxAuditivos("");
                      setFechaAdaptacionAuxAud("");
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      autoComplete="new-password"
                      label="Seleccione"
                      variant="outlined"
                      error={isvalid_UtilizaAuxAuditivos}
                      helperText={isvalid_UtilizaAuxAuditivos ? "Campo obligatorio *" : ""}
                      onFocus={() => {
                        isvalid_setUtilizaAuxAuditivos(false);
                        if (!IdiomaMadre) {
                          isvalid_setIdiomaMadre(true);
                        }
                        if (!IdiomaPadre) {
                          isvalid_setIdiomaPadre(true);
                        }
                        if (!IdiomaEnCasa) {
                          isvalid_setIdiomaEnCasa(true);
                        }
                        if (EvaluadoAudiologia == null) {
                          isvalid_setEvaluadoAudiologia(true);
                        }
                        if (!AudiologoEvalua && EvaluadoAudiologia == 1) {
                          isvalid_setAudiologoEvalua(true);
                        }
                        if (EvaluadoOtorrino == null) {
                          isvalid_setEvaluadoOtorrino(true);
                        }
                        if (!OtorrinoEvalua && EvaluadoOtorrino == 1) {
                          isvalid_setOtorrinoEvalua(true);
                        }
                        if (EvaluadoTerapiaLenguaje == null) {
                          isvalid_setEvaluadoTerapiaLenguaje(true);
                        }
                        if (!TerapeutaEvalua && EvaluadoTerapiaLenguaje == 1) {
                          isvalid_setTerapeutaEvalua(true);
                        }
                        if (!FechaPerdidaAuditiva) {
                          isvalid_setFechaPerdidaAuditiva(true);
                        }
                        if (!TiempoInicioPerdidaAud) {
                          isvalid_setTiempoInicioPerdidaAud(true);
                        }
                        if (!ProfQueDiagnostico) {
                          isvalid_setProfQueDiagnostico(true);
                        }
                        if (!CausaPerdidaAuditiva) {
                          isvalid_setCausaPerdidaAuditiva(true);
                        }
                        if (IdTipoPerdidaAuditiva == null) {
                          isvalid_setIdTipoPerdidaAuditiva(true);
                        }
                        if (!GradoHipoacusia) {
                          isvalid_setGradoHipoacusia(true);
                        }
                        if (TieneEstudiosAudicion == null) {
                          isvalid_setTieneEstudiosAudicion(true);
                        }
                        if (!EstudiosAudicion && TieneEstudiosAudicion == 1) {
                          isvalid_setEstudiosAudicion(true);
                        }
                        if (!DiagnosticoAudicion && TieneEstudiosAudicion == 1) {
                          isvalid_setDiagnosticoAudicion(true);
                        }
                      }}
                      onBlur={() => {
                        if (UtilizaAuxAuditivos == null) isvalid_setUtilizaAuxAuditivos(true);
                      }}
                    />
                  )}
                  style={{ width: "100%", marginBottom: "1rem" }}
                  size="small"
                />
              </Grid>
              <Grid item xs={12} md={2} lg={2}>
                <MDBox textAlign="right">
                  <MDTypography
                    variant="h6"
                    color="white"
                    style={{ opacity: 0.7, fontSize: "0.9rem" }}
                  >
                    Marca y Modelo
                  </MDTypography>
                </MDBox>
              </Grid>
              <Grid item xs={12} md={6} lg={6}>
                <TextField
                  fullWidth
                  variant="outlined"
                  label="Especifique"
                  autoComplete="off"
                  disabled={desactivar}
                  value={MarcaAuxAuditivos}
                  error={isvalid_MarcaAuxAuditivos}
                  helperText={isvalid_MarcaAuxAuditivos ? "Campo obligatorio *" : ""}
                  onFocus={() => {
                    isvalid_setMarcaAuxAuditivos(false);
                    if (!IdiomaMadre) {
                      isvalid_setIdiomaMadre(true);
                    }
                    if (!IdiomaPadre) {
                      isvalid_setIdiomaPadre(true);
                    }
                    if (!IdiomaEnCasa) {
                      isvalid_setIdiomaEnCasa(true);
                    }
                    if (EvaluadoAudiologia == null) {
                      isvalid_setEvaluadoAudiologia(true);
                    }
                    if (!AudiologoEvalua && EvaluadoAudiologia == 1) {
                      isvalid_setAudiologoEvalua(true);
                    }
                    if (EvaluadoOtorrino == null) {
                      isvalid_setEvaluadoOtorrino(true);
                    }
                    if (!OtorrinoEvalua && EvaluadoOtorrino == 1) {
                      isvalid_setOtorrinoEvalua(true);
                    }
                    if (EvaluadoTerapiaLenguaje == null) {
                      isvalid_setEvaluadoTerapiaLenguaje(true);
                    }
                    if (!TerapeutaEvalua && EvaluadoTerapiaLenguaje == 1) {
                      isvalid_setTerapeutaEvalua(true);
                    }
                    if (!FechaPerdidaAuditiva) {
                      isvalid_setFechaPerdidaAuditiva(true);
                    }
                    if (!TiempoInicioPerdidaAud) {
                      isvalid_setTiempoInicioPerdidaAud(true);
                    }
                    if (!ProfQueDiagnostico) {
                      isvalid_setProfQueDiagnostico(true);
                    }
                    if (!CausaPerdidaAuditiva) {
                      isvalid_setCausaPerdidaAuditiva(true);
                    }
                    if (IdTipoPerdidaAuditiva == null) {
                      isvalid_setIdTipoPerdidaAuditiva(true);
                    }
                    if (!GradoHipoacusia) {
                      isvalid_setGradoHipoacusia(true);
                    }
                    if (TieneEstudiosAudicion == null) {
                      isvalid_setTieneEstudiosAudicion(true);
                    }
                    if (!EstudiosAudicion && TieneEstudiosAudicion == 1) {
                      isvalid_setEstudiosAudicion(true);
                    }
                    if (!DiagnosticoAudicion && TieneEstudiosAudicion == 1) {
                      isvalid_setDiagnosticoAudicion(true);
                    }
                    if (UtilizaAuxAuditivos == null) {
                      isvalid_setUtilizaAuxAuditivos(true);
                    }
                  }}
                  onChange={(e) => {
                    if (UtilizaAuxAuditivos != null && UtilizaAuxAuditivos == "1") {
                      setMarcaAuxAuditivos(e.target.value);
                    }
                  }}
                  onBlur={() => {
                    if (
                      !MarcaAuxAuditivos &&
                      UtilizaAuxAuditivos != null &&
                      UtilizaAuxAuditivos == "1"
                    ) {
                      isvalid_setMarcaAuxAuditivos(true);
                    }
                  }}
                  size="small"
                  style={{ marginBottom: "1rem" }}
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
            </Grid>
          </Grid>

          {/* Fecha de adaptación de auxiliares auditivos */}
          <Grid item xs={12} md={3} lg={3}>
            <MDBox textAlign="right">
              <MDTypography variant="h6" color="white" style={{ opacity: 0.7, fontSize: "0.9rem" }}>
                Fecha de la 1a adaptación de auxiliares auditivos:
              </MDTypography>
            </MDBox>
          </Grid>
          <Grid item xs={12} md={9} lg={9}>
            <TextField
              fullWidth
              variant="outlined"
              label="Fecha"
              type="date"
              InputLabelProps={{ shrink: true }}
              value={FechaAdaptacionAuxAud}
              error={isvalid_FechaAdaptacionAuxAud}
              helperText={isvalid_FechaAdaptacionAuxAud ? "Campo obligatorio *" : ""}
              onFocus={() => {
                isvalid_setFechaAdaptacionAuxAud(false);
                if (!IdiomaMadre) {
                  isvalid_setIdiomaMadre(true);
                }
                if (!IdiomaPadre) {
                  isvalid_setIdiomaPadre(true);
                }
                if (!IdiomaEnCasa) {
                  isvalid_setIdiomaEnCasa(true);
                }
                if (EvaluadoAudiologia == null) {
                  isvalid_setEvaluadoAudiologia(true);
                }
                if (!AudiologoEvalua && EvaluadoAudiologia == 1) {
                  isvalid_setAudiologoEvalua(true);
                }
                if (EvaluadoOtorrino == null) {
                  isvalid_setEvaluadoOtorrino(true);
                }
                if (!OtorrinoEvalua && EvaluadoOtorrino == 1) {
                  isvalid_setOtorrinoEvalua(true);
                }
                if (EvaluadoTerapiaLenguaje == null) {
                  isvalid_setEvaluadoTerapiaLenguaje(true);
                }
                if (!TerapeutaEvalua && EvaluadoTerapiaLenguaje == 1) {
                  isvalid_setTerapeutaEvalua(true);
                }
                if (!FechaPerdidaAuditiva) {
                  isvalid_setFechaPerdidaAuditiva(true);
                }
                if (!TiempoInicioPerdidaAud) {
                  isvalid_setTiempoInicioPerdidaAud(true);
                }
                if (!ProfQueDiagnostico) {
                  isvalid_setProfQueDiagnostico(true);
                }
                if (!CausaPerdidaAuditiva) {
                  isvalid_setCausaPerdidaAuditiva(true);
                }
                if (IdTipoPerdidaAuditiva == null) {
                  isvalid_setIdTipoPerdidaAuditiva(true);
                }
                if (!GradoHipoacusia) {
                  isvalid_setGradoHipoacusia(true);
                }
                if (TieneEstudiosAudicion == null) {
                  isvalid_setTieneEstudiosAudicion(true);
                }
                if (!EstudiosAudicion && TieneEstudiosAudicion == 1) {
                  isvalid_setEstudiosAudicion(true);
                }
                if (!DiagnosticoAudicion && TieneEstudiosAudicion == 1) {
                  isvalid_setDiagnosticoAudicion(true);
                }
                if (UtilizaAuxAuditivos == null) {
                  isvalid_setUtilizaAuxAuditivos(true);
                }
                if (!MarcaAuxAuditivos && UtilizaAuxAuditivos == 1) {
                  isvalid_setMarcaAuxAuditivos(true);
                }
              }}
              onChange={(e) => {
                if (UtilizaAuxAuditivos != null && UtilizaAuxAuditivos == "1") {
                  setFechaAdaptacionAuxAud(e.target.value);
                }
              }}
              onBlur={() => {
                if (
                  !FechaAdaptacionAuxAud &&
                  UtilizaAuxAuditivos != null &&
                  UtilizaAuxAuditivos == "1"
                ) {
                  isvalid_setFechaAdaptacionAuxAud(true);
                }
              }}
              size="small"
              onKeyDown={(e) => e.preventDefault()}
              onPaste={(e) => e.preventDefault()}
              autoComplete="off"
              disabled={desactivar}
              inputProps={{
                max: moment().format("YYYY-MM-DD"),
              }}
              onClick={(e) => {
                if (UtilizaAuxAuditivos != null && UtilizaAuxAuditivos == "1") {
                  e.target.showPicker && e.target.showPicker();
                }
              }}
              style={{ marginBottom: "1.5rem", cursor: "pointer" }}
            />
          </Grid>

          {/* Aquí continuarías con los siguientes campos en el mismo formato... */}
        </Grid>

        {/* ¿Le han ajustado los auxiliares auditivos? + ¿Cuándo? */}
        <Grid container spacing={2}>
          <Grid item xs={12} md={3}>
            <MDBox textAlign="right">
              <MDTypography variant="h6" color="white" style={{ opacity: 0.7, fontSize: "0.9rem" }}>
                ¿Le han ajustado auxiliares auditivos?
              </MDTypography>
            </MDBox>
          </Grid>
          <Grid item xs={12} md={9}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={4}>
                <Autocomplete
                  options={[
                    { label: "Sí", value: "1" },
                    { label: "No", value: "0" },
                  ]}
                  getOptionLabel={(option) => option.label}
                  disabled={desactivar}
                  id="HaAjustadoAuxAuditivos"
                  value={
                    [
                      { label: "Sí", value: "1" },
                      { label: "No", value: "0" },
                    ].find((opt) => opt.value == HaAjustadoAuxAuditivos) || null
                  }
                  onChange={(event, newValue) => {
                    setHaAjustadoAuxAuditivos(newValue ? newValue.value : null);
                    if (newValue != null && newValue.value == "1") {
                      isvalid_setFechaAjusteAuxAuditivos(true);
                      isvalid_setAudiologoAjuste(true);
                    } else {
                      isvalid_setFechaAjusteAuxAuditivos(false);
                      isvalid_setAudiologoAjuste(false);
                      setFechaAjusteAuxAuditivos("");
                      setAudiologoAjuste("");
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      autoComplete="new-password"
                      label="Seleccione"
                      variant="outlined"
                      error={isvalid_HaAjustadoAuxAuditivos}
                      helperText={isvalid_HaAjustadoAuxAuditivos ? "Campo obligatorio *" : ""}
                      onFocus={() => {
                        isvalid_setHaAjustadoAuxAuditivos(false);
                        if (!IdiomaMadre) {
                          isvalid_setIdiomaMadre(true);
                        }
                        if (!IdiomaPadre) {
                          isvalid_setIdiomaPadre(true);
                        }
                        if (!IdiomaEnCasa) {
                          isvalid_setIdiomaEnCasa(true);
                        }
                        if (EvaluadoAudiologia == null) {
                          isvalid_setEvaluadoAudiologia(true);
                        }
                        if (!AudiologoEvalua && EvaluadoAudiologia == 1) {
                          isvalid_setAudiologoEvalua(true);
                        }
                        if (EvaluadoOtorrino == null) {
                          isvalid_setEvaluadoOtorrino(true);
                        }
                        if (!OtorrinoEvalua && EvaluadoOtorrino == 1) {
                          isvalid_setOtorrinoEvalua(true);
                        }
                        if (EvaluadoTerapiaLenguaje == null) {
                          isvalid_setEvaluadoTerapiaLenguaje(true);
                        }
                        if (!TerapeutaEvalua && EvaluadoTerapiaLenguaje == 1) {
                          isvalid_setTerapeutaEvalua(true);
                        }
                        if (!FechaPerdidaAuditiva) {
                          isvalid_setFechaPerdidaAuditiva(true);
                        }
                        if (!TiempoInicioPerdidaAud) {
                          isvalid_setTiempoInicioPerdidaAud(true);
                        }
                        if (!ProfQueDiagnostico) {
                          isvalid_setProfQueDiagnostico(true);
                        }
                        if (!CausaPerdidaAuditiva) {
                          isvalid_setCausaPerdidaAuditiva(true);
                        }
                        if (IdTipoPerdidaAuditiva == null) {
                          isvalid_setIdTipoPerdidaAuditiva(true);
                        }
                        if (!GradoHipoacusia) {
                          isvalid_setGradoHipoacusia(true);
                        }
                        if (TieneEstudiosAudicion == null) {
                          isvalid_setTieneEstudiosAudicion(true);
                        }
                        if (!EstudiosAudicion && TieneEstudiosAudicion == 1) {
                          isvalid_setEstudiosAudicion(true);
                        }
                        if (!DiagnosticoAudicion && TieneEstudiosAudicion == 1) {
                          isvalid_setDiagnosticoAudicion(true);
                        }
                        if (UtilizaAuxAuditivos == null) {
                          isvalid_setUtilizaAuxAuditivos(true);
                        }
                        if (!MarcaAuxAuditivos && UtilizaAuxAuditivos == 1) {
                          isvalid_setMarcaAuxAuditivos(true);
                        }
                        if (!FechaAdaptacionAuxAud && UtilizaAuxAuditivos == 1) {
                          isvalid_setFechaAdaptacionAuxAud(true);
                        }
                      }}
                      onBlur={() => {
                        if (HaAjustadoAuxAuditivos == null) isvalid_setHaAjustadoAuxAuditivos(true);
                      }}
                      size="small"
                    />
                  )}
                  style={{ width: "100%", marginBottom: "1rem" }}
                  size="small"
                />
              </Grid>
              <Grid item xs={12} md={2}>
                <MDBox textAlign="right">
                  <MDTypography
                    variant="h6"
                    color="white"
                    style={{ opacity: 0.7, fontSize: "0.9rem" }}
                  >
                    ¿Cuándo?
                  </MDTypography>
                </MDBox>
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  type="date"
                  variant="outlined"
                  InputLabelProps={{ shrink: true }}
                  value={FechaAjusteAuxAuditivos}
                  error={isvalid_FechaAjusteAuxAuditivos}
                  helperText={isvalid_FechaAjusteAuxAuditivos ? "Campo obligatorio *" : ""}
                  onFocus={() => {
                    isvalid_setFechaAjusteAuxAuditivos(false);
                    if (!IdiomaMadre) {
                      isvalid_setIdiomaMadre(true);
                    }
                    if (!IdiomaPadre) {
                      isvalid_setIdiomaPadre(true);
                    }
                    if (!IdiomaEnCasa) {
                      isvalid_setIdiomaEnCasa(true);
                    }
                    if (EvaluadoAudiologia == null) {
                      isvalid_setEvaluadoAudiologia(true);
                    }
                    if (!AudiologoEvalua && EvaluadoAudiologia == 1) {
                      isvalid_setAudiologoEvalua(true);
                    }
                    if (EvaluadoOtorrino == null) {
                      isvalid_setEvaluadoOtorrino(true);
                    }
                    if (!OtorrinoEvalua && EvaluadoOtorrino == 1) {
                      isvalid_setOtorrinoEvalua(true);
                    }
                    if (EvaluadoTerapiaLenguaje == null) {
                      isvalid_setEvaluadoTerapiaLenguaje(true);
                    }
                    if (!TerapeutaEvalua && EvaluadoTerapiaLenguaje == 1) {
                      isvalid_setTerapeutaEvalua(true);
                    }
                    if (!FechaPerdidaAuditiva) {
                      isvalid_setFechaPerdidaAuditiva(true);
                    }
                    if (!TiempoInicioPerdidaAud) {
                      isvalid_setTiempoInicioPerdidaAud(true);
                    }
                    if (!ProfQueDiagnostico) {
                      isvalid_setProfQueDiagnostico(true);
                    }
                    if (!CausaPerdidaAuditiva) {
                      isvalid_setCausaPerdidaAuditiva(true);
                    }
                    if (IdTipoPerdidaAuditiva == null) {
                      isvalid_setIdTipoPerdidaAuditiva(true);
                    }
                    if (!GradoHipoacusia) {
                      isvalid_setGradoHipoacusia(true);
                    }
                    if (TieneEstudiosAudicion == null) {
                      isvalid_setTieneEstudiosAudicion(true);
                    }
                    if (!EstudiosAudicion && TieneEstudiosAudicion == 1) {
                      isvalid_setEstudiosAudicion(true);
                    }
                    if (!DiagnosticoAudicion && TieneEstudiosAudicion == 1) {
                      isvalid_setDiagnosticoAudicion(true);
                    }
                    if (UtilizaAuxAuditivos == null) {
                      isvalid_setUtilizaAuxAuditivos(true);
                    }
                    if (!MarcaAuxAuditivos && UtilizaAuxAuditivos == 1) {
                      isvalid_setMarcaAuxAuditivos(true);
                    }
                    if (!FechaAdaptacionAuxAud && UtilizaAuxAuditivos == 1) {
                      isvalid_setFechaAdaptacionAuxAud(true);
                    }
                    if (HaAjustadoAuxAuditivos == null) {
                      isvalid_setHaAjustadoAuxAuditivos(true);
                    }
                  }}
                  onChange={(e) => {
                    if (HaAjustadoAuxAuditivos != null && HaAjustadoAuxAuditivos == "1") {
                      setFechaAjusteAuxAuditivos(e.target.value);
                    }
                  }}
                  onBlur={() => {
                    if (
                      !FechaAjusteAuxAuditivos &&
                      HaAjustadoAuxAuditivos != null &&
                      HaAjustadoAuxAuditivos == "1"
                    ) {
                      isvalid_setFechaAjusteAuxAuditivos(true);
                    }
                  }}
                  size="small"
                  onKeyDown={(e) => e.preventDefault()}
                  onPaste={(e) => e.preventDefault()}
                  autoComplete="off"
                  disabled={desactivar}
                  inputProps={{
                    max: moment().format("YYYY-MM-DD"),
                  }}
                  onClick={(e) => {
                    if (HaAjustadoAuxAuditivos != null && HaAjustadoAuxAuditivos == "1") {
                      e.target.showPicker && e.target.showPicker();
                    }
                  }}
                  style={{ marginBottom: "1.5rem", cursor: "pointer" }}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        {/* Nombre del Audiólogo que los ajustó */}
        <Grid container spacing={2}>
          <Grid item xs={12} md={3}>
            <MDBox textAlign="right">
              <MDTypography variant="h6" color="white" style={{ opacity: 0.7, fontSize: "0.9rem" }}>
                Nombre del Audiólogo que los ajustó:
              </MDTypography>
            </MDBox>
          </Grid>
          <Grid item xs={12} md={9}>
            <TextField
              fullWidth
              variant="outlined"
              label="Nombre"
              autoComplete="off"
              disabled={desactivar}
              value={AudiologoAjuste}
              error={isvalid_AudiologoAjuste}
              helperText={isvalid_AudiologoAjuste ? "Campo obligatorio *" : ""}
              onFocus={() => {
                isvalid_setAudiologoAjuste(false);
                if (!IdiomaMadre) {
                  isvalid_setIdiomaMadre(true);
                }
                if (!IdiomaPadre) {
                  isvalid_setIdiomaPadre(true);
                }
                if (!IdiomaEnCasa) {
                  isvalid_setIdiomaEnCasa(true);
                }
                if (EvaluadoAudiologia == null) {
                  isvalid_setEvaluadoAudiologia(true);
                }
                if (!AudiologoEvalua && EvaluadoAudiologia == 1) {
                  isvalid_setAudiologoEvalua(true);
                }
                if (EvaluadoOtorrino == null) {
                  isvalid_setEvaluadoOtorrino(true);
                }
                if (!OtorrinoEvalua && EvaluadoOtorrino == 1) {
                  isvalid_setOtorrinoEvalua(true);
                }
                if (EvaluadoTerapiaLenguaje == null) {
                  isvalid_setEvaluadoTerapiaLenguaje(true);
                }
                if (!TerapeutaEvalua && EvaluadoTerapiaLenguaje == 1) {
                  isvalid_setTerapeutaEvalua(true);
                }
                if (!FechaPerdidaAuditiva) {
                  isvalid_setFechaPerdidaAuditiva(true);
                }
                if (!TiempoInicioPerdidaAud) {
                  isvalid_setTiempoInicioPerdidaAud(true);
                }
                if (!ProfQueDiagnostico) {
                  isvalid_setProfQueDiagnostico(true);
                }
                if (!CausaPerdidaAuditiva) {
                  isvalid_setCausaPerdidaAuditiva(true);
                }
                if (IdTipoPerdidaAuditiva == null) {
                  isvalid_setIdTipoPerdidaAuditiva(true);
                }
                if (!GradoHipoacusia) {
                  isvalid_setGradoHipoacusia(true);
                }
                if (TieneEstudiosAudicion == null) {
                  isvalid_setTieneEstudiosAudicion(true);
                }
                if (!EstudiosAudicion && TieneEstudiosAudicion == 1) {
                  isvalid_setEstudiosAudicion(true);
                }
                if (!DiagnosticoAudicion && TieneEstudiosAudicion == 1) {
                  isvalid_setDiagnosticoAudicion(true);
                }
                if (UtilizaAuxAuditivos == null) {
                  isvalid_setUtilizaAuxAuditivos(true);
                }
                if (!MarcaAuxAuditivos && UtilizaAuxAuditivos == 1) {
                  isvalid_setMarcaAuxAuditivos(true);
                }
                if (!FechaAdaptacionAuxAud && UtilizaAuxAuditivos == 1) {
                  isvalid_setFechaAdaptacionAuxAud(true);
                }
                if (HaAjustadoAuxAuditivos == null) {
                  isvalid_setHaAjustadoAuxAuditivos(true);
                }
                if (!FechaAjusteAuxAuditivos && HaAjustadoAuxAuditivos == 1) {
                  isvalid_setFechaAjusteAuxAuditivos(true);
                }
              }}
              onChange={(e) => {
                if (HaAjustadoAuxAuditivos != null && HaAjustadoAuxAuditivos == "1") {
                  setAudiologoAjuste(e.target.value);
                }
              }}
              onBlur={() => {
                if (
                  !AudiologoAjuste &&
                  HaAjustadoAuxAuditivos != null &&
                  HaAjustadoAuxAuditivos == "1"
                ) {
                  isvalid_setAudiologoAjuste(true);
                }
              }}
              size="small"
              style={{ marginBottom: "1rem" }}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
        </Grid>
        {/* ¿Ha recibido Terapia Auditiva-Verbal? + ¿Con quién? */}
        <Grid container spacing={2}>
          <Grid item xs={12} md={3}>
            <MDBox textAlign="right">
              <MDTypography variant="h6" color="white" style={{ opacity: 0.7, fontSize: "0.9rem" }}>
                ¿Ha recibido Terapia Auditiva-Verbal?
              </MDTypography>
            </MDBox>
          </Grid>
          <Grid item xs={12} md={9}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={4}>
                <Autocomplete
                  options={[
                    { label: "Sí", value: "1" },
                    { label: "No", value: "0" },
                  ]}
                  getOptionLabel={(option) => option.label}
                  disabled={desactivar}
                  id="HaRecibidoTerapiaAudVerbal"
                  value={
                    [
                      { label: "Sí", value: "1" },
                      { label: "No", value: "0" },
                    ].find((opt) => opt.value == HaRecibidoTerapiaAudVerbal) || null
                  }
                  onChange={(event, newValue) => {
                    setHaRecibidoTerapiaAudVerbal(newValue ? newValue.value : null);
                    if (newValue != null && newValue.value == "1") {
                      isvalid_setTerapiaAudVerbalQuien(true);
                      isvalid_setProgresosObtenidos(true);
                    } else {
                      isvalid_setTerapiaAudVerbalQuien(false);
                      isvalid_setProgresosObtenidos(false);
                      setTerapiaAudVerbalQuien("");
                      setProgresosObtenidos("");
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      autoComplete="new-password"
                      label="Seleccione"
                      variant="outlined"
                      error={isvalid_HaRecibidoTerapiaAudVerbal}
                      helperText={isvalid_HaRecibidoTerapiaAudVerbal ? "Campo obligatorio *" : ""}
                      onFocus={() => {
                        isvalid_setHaRecibidoTerapiaAudVerbal(false);
                        if (!IdiomaMadre) {
                          isvalid_setIdiomaMadre(true);
                        }
                        if (!IdiomaPadre) {
                          isvalid_setIdiomaPadre(true);
                        }
                        if (!IdiomaEnCasa) {
                          isvalid_setIdiomaEnCasa(true);
                        }
                        if (EvaluadoAudiologia == null) {
                          isvalid_setEvaluadoAudiologia(true);
                        }
                        if (!AudiologoEvalua && EvaluadoAudiologia == 1) {
                          isvalid_setAudiologoEvalua(true);
                        }
                        if (EvaluadoOtorrino == null) {
                          isvalid_setEvaluadoOtorrino(true);
                        }
                        if (!OtorrinoEvalua && EvaluadoOtorrino == 1) {
                          isvalid_setOtorrinoEvalua(true);
                        }
                        if (EvaluadoTerapiaLenguaje == null) {
                          isvalid_setEvaluadoTerapiaLenguaje(true);
                        }
                        if (!TerapeutaEvalua && EvaluadoTerapiaLenguaje == 1) {
                          isvalid_setTerapeutaEvalua(true);
                        }
                        if (!FechaPerdidaAuditiva) {
                          isvalid_setFechaPerdidaAuditiva(true);
                        }
                        if (!TiempoInicioPerdidaAud) {
                          isvalid_setTiempoInicioPerdidaAud(true);
                        }
                        if (!ProfQueDiagnostico) {
                          isvalid_setProfQueDiagnostico(true);
                        }
                        if (!CausaPerdidaAuditiva) {
                          isvalid_setCausaPerdidaAuditiva(true);
                        }
                        if (IdTipoPerdidaAuditiva == null) {
                          isvalid_setIdTipoPerdidaAuditiva(true);
                        }
                        if (!GradoHipoacusia) {
                          isvalid_setGradoHipoacusia(true);
                        }
                        if (TieneEstudiosAudicion == null) {
                          isvalid_setTieneEstudiosAudicion(true);
                        }
                        if (!EstudiosAudicion && TieneEstudiosAudicion == 1) {
                          isvalid_setEstudiosAudicion(true);
                        }
                        if (!DiagnosticoAudicion && TieneEstudiosAudicion == 1) {
                          isvalid_setDiagnosticoAudicion(true);
                        }
                        if (UtilizaAuxAuditivos == null) {
                          isvalid_setUtilizaAuxAuditivos(true);
                        }
                        if (!MarcaAuxAuditivos && UtilizaAuxAuditivos == 1) {
                          isvalid_setMarcaAuxAuditivos(true);
                        }
                        if (!FechaAdaptacionAuxAud && UtilizaAuxAuditivos == 1) {
                          isvalid_setFechaAdaptacionAuxAud(true);
                        }
                        if (HaAjustadoAuxAuditivos == null) {
                          isvalid_setHaAjustadoAuxAuditivos(true);
                        }
                        if (!FechaAjusteAuxAuditivos && HaAjustadoAuxAuditivos == 1) {
                          isvalid_setFechaAjusteAuxAuditivos(true);
                        }
                        if (!AudiologoAjuste && HaAjustadoAuxAuditivos == 1) {
                          isvalid_setAudiologoAjuste(true);
                        }
                      }}
                      onBlur={() => {
                        if (HaRecibidoTerapiaAudVerbal == null)
                          isvalid_setHaRecibidoTerapiaAudVerbal(true);
                      }}
                      size="small"
                    />
                  )}
                  style={{ width: "100%", marginBottom: "1rem" }}
                  size="small"
                />
              </Grid>
              <Grid item xs={12} md={2}>
                <MDBox textAlign="right">
                  <MDTypography
                    variant="h6"
                    color="white"
                    style={{ opacity: 0.7, fontSize: "0.9rem" }}
                  >
                    ¿Con quién?
                  </MDTypography>
                </MDBox>
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  variant="outlined"
                  label="Especifique"
                  autoComplete="off"
                  disabled={desactivar}
                  value={TerapiaAudVerbalQuien}
                  error={isvalid_TerapiaAudVerbalQuien}
                  helperText={isvalid_TerapiaAudVerbalQuien ? "Campo obligatorio *" : ""}
                  onFocus={() => {
                    isvalid_setTerapiaAudVerbalQuien(false);
                    if (!IdiomaMadre) {
                      isvalid_setIdiomaMadre(true);
                    }
                    if (!IdiomaPadre) {
                      isvalid_setIdiomaPadre(true);
                    }
                    if (!IdiomaEnCasa) {
                      isvalid_setIdiomaEnCasa(true);
                    }
                    if (EvaluadoAudiologia == null) {
                      isvalid_setEvaluadoAudiologia(true);
                    }
                    if (!AudiologoEvalua && EvaluadoAudiologia == 1) {
                      isvalid_setAudiologoEvalua(true);
                    }
                    if (EvaluadoOtorrino == null) {
                      isvalid_setEvaluadoOtorrino(true);
                    }
                    if (!OtorrinoEvalua && EvaluadoOtorrino == 1) {
                      isvalid_setOtorrinoEvalua(true);
                    }
                    if (EvaluadoTerapiaLenguaje == null) {
                      isvalid_setEvaluadoTerapiaLenguaje(true);
                    }
                    if (!TerapeutaEvalua && EvaluadoTerapiaLenguaje == 1) {
                      isvalid_setTerapeutaEvalua(true);
                    }
                    if (!FechaPerdidaAuditiva) {
                      isvalid_setFechaPerdidaAuditiva(true);
                    }
                    if (!TiempoInicioPerdidaAud) {
                      isvalid_setTiempoInicioPerdidaAud(true);
                    }
                    if (!ProfQueDiagnostico) {
                      isvalid_setProfQueDiagnostico(true);
                    }
                    if (!CausaPerdidaAuditiva) {
                      isvalid_setCausaPerdidaAuditiva(true);
                    }
                    if (IdTipoPerdidaAuditiva == null) {
                      isvalid_setIdTipoPerdidaAuditiva(true);
                    }
                    if (!GradoHipoacusia) {
                      isvalid_setGradoHipoacusia(true);
                    }
                    if (TieneEstudiosAudicion == null) {
                      isvalid_setTieneEstudiosAudicion(true);
                    }
                    if (!EstudiosAudicion && TieneEstudiosAudicion == 1) {
                      isvalid_setEstudiosAudicion(true);
                    }
                    if (!DiagnosticoAudicion && TieneEstudiosAudicion == 1) {
                      isvalid_setDiagnosticoAudicion(true);
                    }
                    if (UtilizaAuxAuditivos == null) {
                      isvalid_setUtilizaAuxAuditivos(true);
                    }
                    if (!MarcaAuxAuditivos && UtilizaAuxAuditivos == 1) {
                      isvalid_setMarcaAuxAuditivos(true);
                    }
                    if (!FechaAdaptacionAuxAud && UtilizaAuxAuditivos == 1) {
                      isvalid_setFechaAdaptacionAuxAud(true);
                    }
                    if (HaAjustadoAuxAuditivos == null) {
                      isvalid_setHaAjustadoAuxAuditivos(true);
                    }
                    if (!FechaAjusteAuxAuditivos && HaAjustadoAuxAuditivos == 1) {
                      isvalid_setFechaAjusteAuxAuditivos(true);
                    }
                    if (!AudiologoAjuste && HaAjustadoAuxAuditivos == 1) {
                      isvalid_setAudiologoAjuste(true);
                    }
                    if (HaRecibidoTerapiaAudVerbal == null) {
                      isvalid_setHaRecibidoTerapiaAudVerbal(true);
                    }
                  }}
                  onChange={(e) => {
                    if (HaRecibidoTerapiaAudVerbal != null && HaRecibidoTerapiaAudVerbal == "1") {
                      setTerapiaAudVerbalQuien(e.target.value);
                    }
                  }}
                  onBlur={() => {
                    if (
                      !TerapiaAudVerbalQuien &&
                      HaRecibidoTerapiaAudVerbal != null &&
                      HaRecibidoTerapiaAudVerbal == "1"
                    ) {
                      isvalid_setTerapiaAudVerbalQuien(true);
                    }
                  }}
                  size="small"
                  style={{ marginBottom: "1rem" }}
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        {/* Progresos obtenidos */}
        <Grid container spacing={2}>
          <Grid item xs={12} md={3}>
            <MDBox textAlign="right">
              <MDTypography variant="h6" color="white" style={{ opacity: 0.7, fontSize: "0.9rem" }}>
                Progresos obtenidos:
              </MDTypography>
            </MDBox>
          </Grid>
          <Grid item xs={12} md={9}>
            <TextField
              fullWidth
              variant="outlined"
              label="Describa los progresos"
              autoComplete="off"
              disabled={desactivar}
              value={ProgresosObtenidos}
              error={isvalid_ProgresosObtenidos}
              helperText={isvalid_ProgresosObtenidos ? "Campo obligatorio *" : ""}
              onFocus={() => {
                isvalid_setProgresosObtenidos(false);
                if (!IdiomaMadre) {
                  isvalid_setIdiomaMadre(true);
                }
                if (!IdiomaPadre) {
                  isvalid_setIdiomaPadre(true);
                }
                if (!IdiomaEnCasa) {
                  isvalid_setIdiomaEnCasa(true);
                }
                if (EvaluadoAudiologia == null) {
                  isvalid_setEvaluadoAudiologia(true);
                }
                if (!AudiologoEvalua && EvaluadoAudiologia == 1) {
                  isvalid_setAudiologoEvalua(true);
                }
                if (EvaluadoOtorrino == null) {
                  isvalid_setEvaluadoOtorrino(true);
                }
                if (!OtorrinoEvalua && EvaluadoOtorrino == 1) {
                  isvalid_setOtorrinoEvalua(true);
                }
                if (EvaluadoTerapiaLenguaje == null) {
                  isvalid_setEvaluadoTerapiaLenguaje(true);
                }
                if (!TerapeutaEvalua && EvaluadoTerapiaLenguaje == 1) {
                  isvalid_setTerapeutaEvalua(true);
                }
                if (!FechaPerdidaAuditiva) {
                  isvalid_setFechaPerdidaAuditiva(true);
                }
                if (!TiempoInicioPerdidaAud) {
                  isvalid_setTiempoInicioPerdidaAud(true);
                }
                if (!ProfQueDiagnostico) {
                  isvalid_setProfQueDiagnostico(true);
                }
                if (!CausaPerdidaAuditiva) {
                  isvalid_setCausaPerdidaAuditiva(true);
                }
                if (IdTipoPerdidaAuditiva == null) {
                  isvalid_setIdTipoPerdidaAuditiva(true);
                }
                if (!GradoHipoacusia) {
                  isvalid_setGradoHipoacusia(true);
                }
                if (TieneEstudiosAudicion == null) {
                  isvalid_setTieneEstudiosAudicion(true);
                }
                if (!EstudiosAudicion && TieneEstudiosAudicion == 1) {
                  isvalid_setEstudiosAudicion(true);
                }
                if (!DiagnosticoAudicion && TieneEstudiosAudicion == 1) {
                  isvalid_setDiagnosticoAudicion(true);
                }
                if (UtilizaAuxAuditivos == null) {
                  isvalid_setUtilizaAuxAuditivos(true);
                }
                if (!MarcaAuxAuditivos && UtilizaAuxAuditivos == 1) {
                  isvalid_setMarcaAuxAuditivos(true);
                }
                if (!FechaAdaptacionAuxAud && UtilizaAuxAuditivos == 1) {
                  isvalid_setFechaAdaptacionAuxAud(true);
                }
                if (HaAjustadoAuxAuditivos == null) {
                  isvalid_setHaAjustadoAuxAuditivos(true);
                }
                if (!FechaAjusteAuxAuditivos && HaAjustadoAuxAuditivos == 1) {
                  isvalid_setFechaAjusteAuxAuditivos(true);
                }
                if (!AudiologoAjuste && HaAjustadoAuxAuditivos == 1) {
                  isvalid_setAudiologoAjuste(true);
                }
                if (HaRecibidoTerapiaAudVerbal == null) {
                  isvalid_setHaRecibidoTerapiaAudVerbal(true);
                }
                if (!TerapiaAudVerbalQuien && HaRecibidoTerapiaAudVerbal == 1) {
                  isvalid_setTerapiaAudVerbalQuien(true);
                }
              }}
              onChange={(e) => {
                if (HaRecibidoTerapiaAudVerbal != null && HaRecibidoTerapiaAudVerbal == "1") {
                  setProgresosObtenidos(e.target.value);
                }
              }}
              onBlur={() => {
                if (
                  !ProgresosObtenidos &&
                  HaRecibidoTerapiaAudVerbal != null &&
                  HaRecibidoTerapiaAudVerbal == "1"
                ) {
                  isvalid_setProgresosObtenidos(true);
                }
              }}
              size="small"
              style={{ marginBottom: "1rem" }}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
        </Grid>

        {/* Describa su lenguaje actualmente */}
        <Grid container spacing={2}>
          <Grid item xs={12} md={3}>
            <MDBox textAlign="right">
              <MDTypography variant="h6" color="white" style={{ opacity: 0.7, fontSize: "0.9rem" }}>
                Describa su lenguaje actualmente:
              </MDTypography>
            </MDBox>
          </Grid>
          <Grid item xs={12} md={9}>
            <TextField
              fullWidth
              variant="outlined"
              label="Describa"
              autoComplete="off"
              disabled={desactivar}
              value={LenguajeActual}
              onChange={(e) => setLenguajeActual(e.target.value)}
              error={isvalid_LenguajeActual}
              helperText={isvalid_LenguajeActual ? "Campo obligatorio *" : ""}
              onFocus={() => {
                if (!IdiomaMadre) {
                  isvalid_setIdiomaMadre(true);
                }
                if (!IdiomaPadre) {
                  isvalid_setIdiomaPadre(true);
                }
                if (!IdiomaEnCasa) {
                  isvalid_setIdiomaEnCasa(true);
                }
                if (EvaluadoAudiologia == null) {
                  isvalid_setEvaluadoAudiologia(true);
                }
                if (!AudiologoEvalua && EvaluadoAudiologia == 1) {
                  isvalid_setAudiologoEvalua(true);
                }
                if (EvaluadoOtorrino == null) {
                  isvalid_setEvaluadoOtorrino(true);
                }
                if (!OtorrinoEvalua && EvaluadoOtorrino == 1) {
                  isvalid_setOtorrinoEvalua(true);
                }
                if (EvaluadoTerapiaLenguaje == null) {
                  isvalid_setEvaluadoTerapiaLenguaje(true);
                }
                if (!TerapeutaEvalua && EvaluadoTerapiaLenguaje == 1) {
                  isvalid_setTerapeutaEvalua(true);
                }
                if (!FechaPerdidaAuditiva) {
                  isvalid_setFechaPerdidaAuditiva(true);
                }
                if (!TiempoInicioPerdidaAud) {
                  isvalid_setTiempoInicioPerdidaAud(true);
                }
                if (!ProfQueDiagnostico) {
                  isvalid_setProfQueDiagnostico(true);
                }
                if (!CausaPerdidaAuditiva) {
                  isvalid_setCausaPerdidaAuditiva(true);
                }
                if (IdTipoPerdidaAuditiva == null) {
                  isvalid_setIdTipoPerdidaAuditiva(true);
                }
                if (!GradoHipoacusia) {
                  isvalid_setGradoHipoacusia(true);
                }
                if (TieneEstudiosAudicion == null) {
                  isvalid_setTieneEstudiosAudicion(true);
                }
                if (!EstudiosAudicion && TieneEstudiosAudicion == 1) {
                  isvalid_setEstudiosAudicion(true);
                }
                if (!DiagnosticoAudicion && TieneEstudiosAudicion == 1) {
                  isvalid_setDiagnosticoAudicion(true);
                }
                if (UtilizaAuxAuditivos == null) {
                  isvalid_setUtilizaAuxAuditivos(true);
                }
                if (!MarcaAuxAuditivos && UtilizaAuxAuditivos == 1) {
                  isvalid_setMarcaAuxAuditivos(true);
                }
                if (!FechaAdaptacionAuxAud && UtilizaAuxAuditivos == 1) {
                  isvalid_setFechaAdaptacionAuxAud(true);
                }
                if (HaAjustadoAuxAuditivos == null) {
                  isvalid_setHaAjustadoAuxAuditivos(true);
                }
                if (!FechaAjusteAuxAuditivos && HaAjustadoAuxAuditivos == 1) {
                  isvalid_setFechaAjusteAuxAuditivos(true);
                }
                if (!AudiologoAjuste && HaAjustadoAuxAuditivos == 1) {
                  isvalid_setAudiologoAjuste(true);
                }
                if (HaRecibidoTerapiaAudVerbal == null) {
                  isvalid_setHaRecibidoTerapiaAudVerbal(true);
                }
                if (!TerapiaAudVerbalQuien && HaRecibidoTerapiaAudVerbal == 1) {
                  isvalid_setTerapiaAudVerbalQuien(true);
                }
                if (!ProgresosObtenidos && HaRecibidoTerapiaAudVerbal == 1) {
                  isvalid_setProgresosObtenidos(true);
                }
              }}
              onBlur={() => {
                if (!LenguajeActual) isvalid_setLenguajeActual(false);
              }}
              size="small"
              style={{ marginBottom: "1rem" }}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
        </Grid>

        {/* ¿Qué escucha y entiende actualmente? */}
        <Grid container spacing={2}>
          <Grid item xs={12} md={3}>
            <MDBox textAlign="right">
              <MDTypography variant="h6" color="white" style={{ opacity: 0.7, fontSize: "0.9rem" }}>
                ¿Qué escucha y entiende actualmente?
              </MDTypography>
            </MDBox>
          </Grid>
          <Grid item xs={12} md={9}>
            <TextField
              fullWidth
              variant="outlined"
              label="Especifique"
              autoComplete="off"
              disabled={desactivar}
              value={EscuchaActualmente}
              onChange={(e) => setEscuchaActualmente(e.target.value)}
              error={isvalid_EscuchaActualmente}
              helperText={isvalid_EscuchaActualmente ? "Campo obligatorio *" : ""}
              onFocus={() => {
                isvalid_setEscuchaActualmente(false);
                if (!IdiomaMadre) {
                  isvalid_setIdiomaMadre(true);
                }
                if (!IdiomaPadre) {
                  isvalid_setIdiomaPadre(true);
                }
                if (!IdiomaEnCasa) {
                  isvalid_setIdiomaEnCasa(true);
                }
                if (EvaluadoAudiologia == null) {
                  isvalid_setEvaluadoAudiologia(true);
                }
                if (!AudiologoEvalua && EvaluadoAudiologia == 1) {
                  isvalid_setAudiologoEvalua(true);
                }
                if (EvaluadoOtorrino == null) {
                  isvalid_setEvaluadoOtorrino(true);
                }
                if (!OtorrinoEvalua && EvaluadoOtorrino == 1) {
                  isvalid_setOtorrinoEvalua(true);
                }
                if (EvaluadoTerapiaLenguaje == null) {
                  isvalid_setEvaluadoTerapiaLenguaje(true);
                }
                if (!TerapeutaEvalua && EvaluadoTerapiaLenguaje == 1) {
                  isvalid_setTerapeutaEvalua(true);
                }
                if (!FechaPerdidaAuditiva) {
                  isvalid_setFechaPerdidaAuditiva(true);
                }
                if (!TiempoInicioPerdidaAud) {
                  isvalid_setTiempoInicioPerdidaAud(true);
                }
                if (!ProfQueDiagnostico) {
                  isvalid_setProfQueDiagnostico(true);
                }
                if (!CausaPerdidaAuditiva) {
                  isvalid_setCausaPerdidaAuditiva(true);
                }
                if (IdTipoPerdidaAuditiva == null) {
                  isvalid_setIdTipoPerdidaAuditiva(true);
                }
                if (!GradoHipoacusia) {
                  isvalid_setGradoHipoacusia(true);
                }
                if (TieneEstudiosAudicion == null) {
                  isvalid_setTieneEstudiosAudicion(true);
                }
                if (!EstudiosAudicion && TieneEstudiosAudicion == 1) {
                  isvalid_setEstudiosAudicion(true);
                }
                if (!DiagnosticoAudicion && TieneEstudiosAudicion == 1) {
                  isvalid_setDiagnosticoAudicion(true);
                }
                if (UtilizaAuxAuditivos == null) {
                  isvalid_setUtilizaAuxAuditivos(true);
                }
                if (!MarcaAuxAuditivos && UtilizaAuxAuditivos == 1) {
                  isvalid_setMarcaAuxAuditivos(true);
                }
                if (!FechaAdaptacionAuxAud && UtilizaAuxAuditivos == 1) {
                  isvalid_setFechaAdaptacionAuxAud(true);
                }
                if (HaAjustadoAuxAuditivos == null) {
                  isvalid_setHaAjustadoAuxAuditivos(true);
                }
                if (!FechaAjusteAuxAuditivos && HaAjustadoAuxAuditivos == 1) {
                  isvalid_setFechaAjusteAuxAuditivos(true);
                }
                if (!AudiologoAjuste && HaAjustadoAuxAuditivos == 1) {
                  isvalid_setAudiologoAjuste(true);
                }
                if (HaRecibidoTerapiaAudVerbal == null) {
                  isvalid_setHaRecibidoTerapiaAudVerbal(true);
                }
                if (!TerapiaAudVerbalQuien && HaRecibidoTerapiaAudVerbal == 1) {
                  isvalid_setTerapiaAudVerbalQuien(true);
                }
                if (!ProgresosObtenidos && HaRecibidoTerapiaAudVerbal == 1) {
                  isvalid_setProgresosObtenidos(true);
                }
                if (!LenguajeActual) {
                  isvalid_setLenguajeActual(true);
                }
              }}
              onBlur={() => {
                if (!EscuchaActualmente) isvalid_setEscuchaActualmente(false);
              }}
              size="small"
              style={{ marginBottom: "1rem" }}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
        </Grid>
        {/* ¿Ha sido evaluado de la vista? */}
        <Grid container spacing={2}>
          <Grid item xs={12} md={3}>
            <MDBox textAlign="right">
              <MDTypography variant="h6" color="white" style={{ opacity: 0.7, fontSize: "0.9rem" }}>
                ¿Ha sido evaluado de la vista?
              </MDTypography>
            </MDBox>
          </Grid>
          <Grid item xs={12} md={9}>
            <Autocomplete
              options={[
                { label: "Sí", value: "1" },
                { label: "No", value: "0" },
              ]}
              getOptionLabel={(option) => option.label}
              disabled={desactivar}
              id="TieneEvaluacionVista"
              value={
                [
                  { label: "Sí", value: "1" },
                  { label: "No", value: "0" },
                ].find((opt) => opt.value == TieneEvaluacionVista) || null
              }
              onChange={(event, newValue) =>
                setTieneEvaluacionVista(newValue ? newValue.value : null)
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  autoComplete="new-password"
                  label="Seleccione"
                  variant="outlined"
                  error={isvalid_TieneEvaluacionVista}
                  helperText={isvalid_TieneEvaluacionVista ? "Campo obligatorio *" : ""}
                  onFocus={() => {
                    isvalid_setTieneEvaluacionVista(false);
                    if (!IdiomaMadre) {
                      isvalid_setIdiomaMadre(true);
                    }
                    if (!IdiomaPadre) {
                      isvalid_setIdiomaPadre(true);
                    }
                    if (!IdiomaEnCasa) {
                      isvalid_setIdiomaEnCasa(true);
                    }
                    if (EvaluadoAudiologia == null) {
                      isvalid_setEvaluadoAudiologia(true);
                    }
                    if (!AudiologoEvalua && EvaluadoAudiologia == 1) {
                      isvalid_setAudiologoEvalua(true);
                    }
                    if (EvaluadoOtorrino == null) {
                      isvalid_setEvaluadoOtorrino(true);
                    }
                    if (!OtorrinoEvalua && EvaluadoOtorrino == 1) {
                      isvalid_setOtorrinoEvalua(true);
                    }
                    if (EvaluadoTerapiaLenguaje == null) {
                      isvalid_setEvaluadoTerapiaLenguaje(true);
                    }
                    if (!TerapeutaEvalua && EvaluadoTerapiaLenguaje == 1) {
                      isvalid_setTerapeutaEvalua(true);
                    }
                    if (!FechaPerdidaAuditiva) {
                      isvalid_setFechaPerdidaAuditiva(true);
                    }
                    if (!TiempoInicioPerdidaAud) {
                      isvalid_setTiempoInicioPerdidaAud(true);
                    }
                    if (!ProfQueDiagnostico) {
                      isvalid_setProfQueDiagnostico(true);
                    }
                    if (!CausaPerdidaAuditiva) {
                      isvalid_setCausaPerdidaAuditiva(true);
                    }
                    if (IdTipoPerdidaAuditiva == null) {
                      isvalid_setIdTipoPerdidaAuditiva(true);
                    }
                    if (!GradoHipoacusia) {
                      isvalid_setGradoHipoacusia(true);
                    }
                    if (TieneEstudiosAudicion == null) {
                      isvalid_setTieneEstudiosAudicion(true);
                    }
                    if (!EstudiosAudicion && TieneEstudiosAudicion == 1) {
                      isvalid_setEstudiosAudicion(true);
                    }
                    if (!DiagnosticoAudicion && TieneEstudiosAudicion == 1) {
                      isvalid_setDiagnosticoAudicion(true);
                    }
                    if (UtilizaAuxAuditivos == null) {
                      isvalid_setUtilizaAuxAuditivos(true);
                    }
                    if (!MarcaAuxAuditivos && UtilizaAuxAuditivos == 1) {
                      isvalid_setMarcaAuxAuditivos(true);
                    }
                    if (!FechaAdaptacionAuxAud && UtilizaAuxAuditivos == 1) {
                      isvalid_setFechaAdaptacionAuxAud(true);
                    }
                    if (HaAjustadoAuxAuditivos == null) {
                      isvalid_setHaAjustadoAuxAuditivos(true);
                    }
                    if (!FechaAjusteAuxAuditivos && HaAjustadoAuxAuditivos == 1) {
                      isvalid_setFechaAjusteAuxAuditivos(true);
                    }
                    if (!AudiologoAjuste && HaAjustadoAuxAuditivos == 1) {
                      isvalid_setAudiologoAjuste(true);
                    }
                    if (HaRecibidoTerapiaAudVerbal == null) {
                      isvalid_setHaRecibidoTerapiaAudVerbal(true);
                    }
                    if (!TerapiaAudVerbalQuien && HaRecibidoTerapiaAudVerbal == 1) {
                      isvalid_setTerapiaAudVerbalQuien(true);
                    }
                    if (!ProgresosObtenidos && HaRecibidoTerapiaAudVerbal == 1) {
                      isvalid_setProgresosObtenidos(true);
                    }
                    if (!LenguajeActual) {
                      isvalid_setLenguajeActual(true);
                    }
                    if (!EscuchaActualmente) {
                      isvalid_setEscuchaActualmente(true);
                    }
                  }}
                  onBlur={() => {
                    if (TieneEvaluacionVista == null) isvalid_setTieneEvaluacionVista(true);
                  }}
                  size="small"
                />
              )}
              style={{ width: "100%", marginBottom: "1rem" }}
              size="small"
            />
          </Grid>
        </Grid>

        {/* ¿Algún retraso en el desarrollo? + ¿Cuál? */}
        <Grid container spacing={2}>
          <Grid item xs={12} md={3}>
            <MDBox textAlign="right">
              <MDTypography variant="h6" color="white" style={{ opacity: 0.7, fontSize: "0.9rem" }}>
                ¿Algún retraso en el desarrollo?
              </MDTypography>
            </MDBox>
          </Grid>
          <Grid item xs={12} md={9}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={4}>
                <Autocomplete
                  options={[
                    { label: "Sí", value: "1" },
                    { label: "No", value: "0" },
                  ]}
                  getOptionLabel={(option) => option.label}
                  disabled={desactivar}
                  id="TieneRetrasoDesarrollo"
                  value={
                    [
                      { label: "Sí", value: "1" },
                      { label: "No", value: "0" },
                    ].find((opt) => opt.value == TieneRetrasoDesarrollo) || null
                  }
                  onChange={(event, newValue) => {
                    setTieneRetrasoDesarrollo(newValue ? newValue.value : null);
                    if (newValue != null && newValue.value == "1") {
                      isvalid_setCualRetraso(true);
                    } else {
                      isvalid_setCualRetraso(false);
                      setCualRetraso("");
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      autoComplete="new-password"
                      label="Seleccione"
                      variant="outlined"
                      error={isvalid_TieneRetrasoDesarrollo}
                      helperText={isvalid_TieneRetrasoDesarrollo ? "Campo obligatorio *" : ""}
                      onFocus={() => {
                        isvalid_setTieneRetrasoDesarrollo(false);
                        if (!IdiomaMadre) {
                          isvalid_setIdiomaMadre(true);
                        }
                        if (!IdiomaPadre) {
                          isvalid_setIdiomaPadre(true);
                        }
                        if (!IdiomaEnCasa) {
                          isvalid_setIdiomaEnCasa(true);
                        }
                        if (EvaluadoAudiologia == null) {
                          isvalid_setEvaluadoAudiologia(true);
                        }
                        if (!AudiologoEvalua && EvaluadoAudiologia == 1) {
                          isvalid_setAudiologoEvalua(true);
                        }
                        if (EvaluadoOtorrino == null) {
                          isvalid_setEvaluadoOtorrino(true);
                        }
                        if (!OtorrinoEvalua && EvaluadoOtorrino == 1) {
                          isvalid_setOtorrinoEvalua(true);
                        }
                        if (EvaluadoTerapiaLenguaje == null) {
                          isvalid_setEvaluadoTerapiaLenguaje(true);
                        }
                        if (!TerapeutaEvalua && EvaluadoTerapiaLenguaje == 1) {
                          isvalid_setTerapeutaEvalua(true);
                        }
                        if (!FechaPerdidaAuditiva) {
                          isvalid_setFechaPerdidaAuditiva(true);
                        }
                        if (!TiempoInicioPerdidaAud) {
                          isvalid_setTiempoInicioPerdidaAud(true);
                        }
                        if (!ProfQueDiagnostico) {
                          isvalid_setProfQueDiagnostico(true);
                        }
                        if (!CausaPerdidaAuditiva) {
                          isvalid_setCausaPerdidaAuditiva(true);
                        }
                        if (IdTipoPerdidaAuditiva == null) {
                          isvalid_setIdTipoPerdidaAuditiva(true);
                        }
                        if (!GradoHipoacusia) {
                          isvalid_setGradoHipoacusia(true);
                        }
                        if (TieneEstudiosAudicion == null) {
                          isvalid_setTieneEstudiosAudicion(true);
                        }
                        if (!EstudiosAudicion && TieneEstudiosAudicion == 1) {
                          isvalid_setEstudiosAudicion(true);
                        }
                        if (!DiagnosticoAudicion && TieneEstudiosAudicion == 1) {
                          isvalid_setDiagnosticoAudicion(true);
                        }
                        if (UtilizaAuxAuditivos == null) {
                          isvalid_setUtilizaAuxAuditivos(true);
                        }
                        if (!MarcaAuxAuditivos && UtilizaAuxAuditivos == 1) {
                          isvalid_setMarcaAuxAuditivos(true);
                        }
                        if (!FechaAdaptacionAuxAud && UtilizaAuxAuditivos == 1) {
                          isvalid_setFechaAdaptacionAuxAud(true);
                        }
                        if (HaAjustadoAuxAuditivos == null) {
                          isvalid_setHaAjustadoAuxAuditivos(true);
                        }
                        if (!FechaAjusteAuxAuditivos && HaAjustadoAuxAuditivos == 1) {
                          isvalid_setFechaAjusteAuxAuditivos(true);
                        }
                        if (!AudiologoAjuste && HaAjustadoAuxAuditivos == 1) {
                          isvalid_setAudiologoAjuste(true);
                        }
                        if (HaRecibidoTerapiaAudVerbal == null) {
                          isvalid_setHaRecibidoTerapiaAudVerbal(true);
                        }
                        if (!TerapiaAudVerbalQuien && HaRecibidoTerapiaAudVerbal == 1) {
                          isvalid_setTerapiaAudVerbalQuien(true);
                        }
                        if (!ProgresosObtenidos && HaRecibidoTerapiaAudVerbal == 1) {
                          isvalid_setProgresosObtenidos(true);
                        }
                        if (!LenguajeActual) {
                          isvalid_setLenguajeActual(true);
                        }
                        if (!EscuchaActualmente) {
                          isvalid_setEscuchaActualmente(true);
                        }
                        if (TieneEvaluacionVista == null) {
                          isvalid_setTieneEvaluacionVista(true);
                        }
                      }}
                      onBlur={() => {
                        if (TieneRetrasoDesarrollo == null) isvalid_setTieneRetrasoDesarrollo(true);
                      }}
                      size="small"
                    />
                  )}
                  style={{ width: "100%", marginBottom: "1rem" }}
                  size="small"
                />
              </Grid>
              <Grid item xs={12} md={2}>
                <MDBox textAlign="right">
                  <MDTypography
                    variant="h6"
                    color="white"
                    style={{ opacity: 0.7, fontSize: "0.9rem" }}
                  >
                    ¿Cuál?
                  </MDTypography>
                </MDBox>
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  variant="outlined"
                  label="Especifique"
                  autoComplete="off"
                  disabled={desactivar}
                  value={CualRetraso}
                  error={isvalid_CualRetraso}
                  helperText={isvalid_CualRetraso ? "Campo obligatorio *" : ""}
                  onFocus={() => {
                    isvalid_setCualRetraso(false);
                    if (!IdiomaMadre) {
                      isvalid_setIdiomaMadre(true);
                    }
                    if (!IdiomaPadre) {
                      isvalid_setIdiomaPadre(true);
                    }
                    if (!IdiomaEnCasa) {
                      isvalid_setIdiomaEnCasa(true);
                    }
                    if (EvaluadoAudiologia == null) {
                      isvalid_setEvaluadoAudiologia(true);
                    }
                    if (!AudiologoEvalua && EvaluadoAudiologia == 1) {
                      isvalid_setAudiologoEvalua(true);
                    }
                    if (EvaluadoOtorrino == null) {
                      isvalid_setEvaluadoOtorrino(true);
                    }
                    if (!OtorrinoEvalua && EvaluadoOtorrino == 1) {
                      isvalid_setOtorrinoEvalua(true);
                    }
                    if (EvaluadoTerapiaLenguaje == null) {
                      isvalid_setEvaluadoTerapiaLenguaje(true);
                    }
                    if (!TerapeutaEvalua && EvaluadoTerapiaLenguaje == 1) {
                      isvalid_setTerapeutaEvalua(true);
                    }
                    if (!FechaPerdidaAuditiva) {
                      isvalid_setFechaPerdidaAuditiva(true);
                    }
                    if (!TiempoInicioPerdidaAud) {
                      isvalid_setTiempoInicioPerdidaAud(true);
                    }
                    if (!ProfQueDiagnostico) {
                      isvalid_setProfQueDiagnostico(true);
                    }
                    if (!CausaPerdidaAuditiva) {
                      isvalid_setCausaPerdidaAuditiva(true);
                    }
                    if (IdTipoPerdidaAuditiva == null) {
                      isvalid_setIdTipoPerdidaAuditiva(true);
                    }
                    if (!GradoHipoacusia) {
                      isvalid_setGradoHipoacusia(true);
                    }
                    if (TieneEstudiosAudicion == null) {
                      isvalid_setTieneEstudiosAudicion(true);
                    }
                    if (!EstudiosAudicion && TieneEstudiosAudicion == 1) {
                      isvalid_setEstudiosAudicion(true);
                    }
                    if (!DiagnosticoAudicion && TieneEstudiosAudicion == 1) {
                      isvalid_setDiagnosticoAudicion(true);
                    }
                    if (UtilizaAuxAuditivos == null) {
                      isvalid_setUtilizaAuxAuditivos(true);
                    }
                    if (!MarcaAuxAuditivos && UtilizaAuxAuditivos == 1) {
                      isvalid_setMarcaAuxAuditivos(true);
                    }
                    if (!FechaAdaptacionAuxAud && UtilizaAuxAuditivos == 1) {
                      isvalid_setFechaAdaptacionAuxAud(true);
                    }
                    if (HaAjustadoAuxAuditivos == null) {
                      isvalid_setHaAjustadoAuxAuditivos(true);
                    }
                    if (!FechaAjusteAuxAuditivos && HaAjustadoAuxAuditivos == 1) {
                      isvalid_setFechaAjusteAuxAuditivos(true);
                    }
                    if (!AudiologoAjuste && HaAjustadoAuxAuditivos == 1) {
                      isvalid_setAudiologoAjuste(true);
                    }
                    if (HaRecibidoTerapiaAudVerbal == null) {
                      isvalid_setHaRecibidoTerapiaAudVerbal(true);
                    }
                    if (!TerapiaAudVerbalQuien && HaRecibidoTerapiaAudVerbal == 1) {
                      isvalid_setTerapiaAudVerbalQuien(true);
                    }
                    if (!ProgresosObtenidos && HaRecibidoTerapiaAudVerbal == 1) {
                      isvalid_setProgresosObtenidos(true);
                    }
                    if (!LenguajeActual) {
                      isvalid_setLenguajeActual(true);
                    }
                    if (!EscuchaActualmente) {
                      isvalid_setEscuchaActualmente(true);
                    }
                    if (TieneEvaluacionVista == null) {
                      isvalid_setTieneEvaluacionVista(true);
                    }
                    if (TieneRetrasoDesarrollo == null) {
                      isvalid_setTieneRetrasoDesarrollo(true);
                    }
                  }}
                  onChange={(e) => {
                    if (TieneRetrasoDesarrollo != null && TieneRetrasoDesarrollo == "1") {
                      setCualRetraso(e.target.value);
                    }
                  }}
                  onBlur={() => {
                    if (
                      !CualRetraso &&
                      TieneRetrasoDesarrollo != null &&
                      TieneRetrasoDesarrollo == "1"
                    ) {
                      isvalid_setCualRetraso(true);
                    }
                  }}
                  size="small"
                  style={{ marginBottom: "1rem" }}
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        {vista === "visualizar" ? null : (
          <MDBox textAlign="right">
            <Button
              variant="contained"
              onClick={() => ValidaForm()}
              sx={{ mt: 1, mr: 1 }}
              size="small"
              color="primary"
            >
              {"Continuar"}
            </Button>
            <Button
              variant="contained"
              disabled={false}
              onClick={() => handleBack()}
              sx={{ mt: 1, mr: 1 }}
              color="secondary"
              size="small"
            >
              Volver
            </Button>
          </MDBox>
        )}
      </>
    );
  }
);
export default EvaluacionAuditiva;
